// ***** Update for same Servitor can Rebook (29-6-25) ***** //

// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";

// import ElectricianOrderForm from "./ElectricianOrderForm";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";

// import heroImage from "../images/electrician.jpg";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import "./electricianStyle.css";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const Electrician = () => {
//   const { t } = useTranslation();

//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });

//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   // const prevOrder   = location.state?.previousOrder || {};

//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   const [useSameServitor, setUseSameServitor] = useState(false); //new added for same servitor rebook
//   const [prevServitorName, setPrevServitorName] = useState(""); //new added for same servitor rebook

//   const [fanInstall, setFanInstall] = useState(0);
//   const [lightInstall, setLightInstall] = useState(0);
//   const [fanRepair, setFanRepair] = useState(0);
//   const [lightRepair, setLightRepair] = useState(0);

//   // ─── New electrician fields ───
//   const [doorbellSetup, setDoorbellSetup] = useState(0);
//   const [exhaustFanSetup, setExhaustFanSetup] = useState(0);
//   const [exhaustFanRepair, setExhaustFanRepair] = useState(0);
//   const [drillWallHoles, setDrillWallHoles] = useState(0);

//   const [switchBoardRepair, setSwitchBoardRepair] = useState(0);
//   const [mcbServicing, setMcbServicing] = useState(0);
//   const [distributionBoardServicing, setDistributionBoardServicing] =
//     useState(0);

//   // -- NEW states for added features --
//   const [regulatorInstall, setRegulatorInstall] = useState(0); // Fan regulator install
//   const [regulatorRepair, setRegulatorRepair] = useState(0); // Fan regulator repair
//   const [socketInstall, setSocketInstall] = useState(0); // Outlet socket install
//   const [socketRepair, setSocketRepair] = useState(0); // Outlet socket repair
//   const [breakerRepair, setBreakerRepair] = useState(0); // Circuit breaker repair
//   const [newWiringPoint, setNewWiringPoint] = useState(0); // Add new wiring point
//   const [coilRepair, setCoilRepair] = useState(0);
//   // const [fullWiring, setFullWiring] = useState(false); // Full wiring (flat fee)
//   // const [checkupPoints, setCheckupPoints] = useState(0);
//   const [needsCheckup, setNeedsCheckup] = useState(false);

//   const [remarks, setRemarks] = useState("");

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);


//   // const [selectedDate, setSelectedDate] = useState(new Date());

//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };

//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   // const [selectedTime, setSelectedTime]   = useState('');

//   useEffect(() => {
//     if (rebookState) {
//       setFanInstall(prevOrder.Fan_in_un || 0);
//       setLightInstall(prevOrder.Light_in_un || 0);
//       setFanRepair(prevOrder.Fan_repair || 0);
//       setLightRepair(prevOrder.Light_repair || 0);

//       setDoorbellSetup(prevOrder.Doorbell_setup || 0);
//       setExhaustFanSetup(prevOrder.Exhaust_fan_setup || 0);
//       setExhaustFanRepair(prevOrder.Exhaust_fan_repair || 0);
//       setDrillWallHoles(prevOrder.Drill_wall_holes || 0);

//       setSwitchBoardRepair(prevOrder.Switch_repair || 0);
//       setMcbServicing(prevOrder.MCB_service || 0);
//       setDistributionBoardServicing(prevOrder.MDB_service || 0);

//       // -- populate new fields on rebook too --
//       setRegulatorInstall(prevOrder.Fan_regulator_in_un || 0);
//       setRegulatorRepair(prevOrder.Fan_regulator_repair || 0);
//       setSocketInstall(prevOrder.Socket_in_un || 0);
//       setSocketRepair(prevOrder.Socket_repair || 0);
//       setBreakerRepair(prevOrder.Circuit_breaker_repair || 0);
//       setNewWiringPoint(prevOrder.New_wiring_point || 0);
//       setCoilRepair(prevOrder.Coil_repair || 0);
//       // setFullWiring(prevOrder.Full_wiring || false);
//       // setCheckupPoints(prevOrder.Electrical_checkup || 0);
//       setNeedsCheckup(prevOrder.Electrical_checkup || false);
//     }
//   }, [rebookState, prevOrder]);

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith("user-")
//             ? userId.split("user-")[1]
//             : userId;

//           const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   //new added for same servitor rebook
//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // Fetch only electrician ratings once
//   // useEffect(() => {
//   //   axios
//   //     .get(`${URL}/api/ratings`)
//   //     .then(({ data }) => {
//   //       const { electrician } = data;
//   //       setRatingData({
//   //         reviewCount: electrician.reviewCount,
//   //         avgRating: electrician.avgRating,
//   //       });
//   //     })
//   //     .catch((err) => console.error("Failed to load ratings:", err));
//   // }, []);

//   useEffect(() => {
//     const loadRatings = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axios.get(`${URL}/api/ratings`);
//         const { electrician = {} } = data;
//         setRatingData({
//           reviewCount: electrician.reviewCount || 0,
//           avgRating: electrician.avgRating || 0,
//         });
//       } catch (err) {
//         console.error("Failed to load ratings:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadRatings();
//   }, []);


//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // const formatDate = (dateStr) => {
//   //   const dateObj = new Date(dateStr);
//   //   if (isNaN(dateObj)) return "";
//   //   const day = dateObj.getDate();
//   //   // Use locale options to get a short month name.
//   //   const month = dateObj.toLocaleString('default', { month: 'short' });
//   //   const year = dateObj.getFullYear();
//   //   return `${day}-${month}-${year}`;
//   // };

//   // Calculate price based on user selections
//   // const calculatePrice = () => {
//   //   let price = 200; // Base price
//   //   price += fanInstall * 50;
//   //   price += lightInstall * 30;
//   //   price += fanRepair * 40;
//   //   price += lightRepair * 30;
//   //   price += switchBoardRepair * 50;
//   //   price += mcbServicing * 100;
//   //   price += distributionBoardServicing * 200;
//   //   return price;
//   // };

//   const calculatePrice = () => {
//     let price = 100; // ← base price lowered to 100

//     // Fan services
//     price += fanInstall * 200; // fan install/uninstall
//     price += fanRepair * 150; // fan repair
//     price += regulatorInstall * 120; // fan regulator install/uninstall
//     price += regulatorRepair * 100; // fan regulator repair

//     // Light services
//     price += lightInstall * 80; // light install/uninstall
//     price += lightRepair * 70; // light repair

//     // Panel & board services
//     price += switchBoardRepair * 150; // switch board repair
//     price += mcbServicing * 100; // MCB servicing (kept)
//     price += distributionBoardServicing * 200; // MDB servicing (kept)
//     price += breakerRepair * 250; // circuit breaker repair

//     // Socket services
//     price += socketInstall * 150; // socket install/uninstall
//     price += socketRepair * 100; // socket repair

//     price += doorbellSetup * 120; // Doorbell install/uninstall
//     price += exhaustFanSetup * 200; // Exhaust fan setup
//     price += exhaustFanRepair * 150; // Exhaust fan repair
//     price += drillWallHoles * 50; // Per hole drilling

//     // Wiring
//     price += newWiringPoint * 350; // new wiring point
//     price += coilRepair * 800; // coil repair
//     // if (fullWiring) price += 1500; // full wiring flat fee

//     // Checkup
//     // price += Math.min(checkupPoints, 3) * 100; // electrical checkup up to 3 points
//     if (needsCheckup) price += 100;

//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     // const date = e.target.date.value;
//     const time = e.target.time.value;
//     // setSelectedDate(date);
//     let dateStr = "";
//     if (selectedDate) {
//       dateStr = selectedDate.toISOString().split("T")[0];
//     }

//     const formDetails = {
//       fanInstall,
//       fanRepair,
//       regulatorInstall,
//       regulatorRepair,
//       lightInstall,
//       lightRepair,
//       doorbellSetup,
//       exhaustFanSetup,
//       exhaustFanRepair,
//       drillWallHoles,
//       socketInstall,
//       socketRepair,
//       switchBoardRepair,
//       mcbServicing,
//       distributionBoardServicing,
//       breakerRepair,
//       newWiringPoint,
//       coilRepair,
//       // fullWiring,
//       // checkupPoints,
//       needsCheckup,

//       remarks,

//       price: calculatePrice(),
//       // date,
//       date: dateStr,
//       time,

//       // new added for rebook same servitor
//       useSameServitor,
//       servitor_id: useSameServitor
//         ? prevOrder.servitor_id // carry through the original servitor’s ID
//         : undefined,
//     };
//     setFormData(formDetails);

//     // If user is logged in, show the order form; otherwise prompt for login
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // Once user confirms the order in ElectricianOrderForm
//   const handleOrderSubmit = (orderData) => {
//     console.log("Order Data:", orderData);
//     setShowOrderForm(false);

//     // 2) Reset _every_ form‐state back to its initial “empty” value:
//     setFanInstall(0);
//     setLightInstall(0);
//     setFanRepair(0);
//     setLightRepair(0);
//     setSwitchBoardRepair(0);
//     setMcbServicing(0);
//     setDistributionBoardServicing(0);
//     setRegulatorInstall(0);
//     setRegulatorRepair(0);
//     setSocketInstall(0);
//     setSocketRepair(0);
//     setBreakerRepair(0);
//     setNewWiringPoint(0);
//     setCoilRepair(0);
//     // setFullWiring(false);
//     setNeedsCheckup(false);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//   };

//   // Get today's date in YYYY-MM-DD format for the min attribute
//   // const todayDate = new Date().toISOString().split('T')[0];

//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const { t } = useTranslation();
//     const handleIncrement = () => {
//       if (value < max) {
//         setValue(value + 1);
//       }
//     };

//     const handleDecrement = () => {
//       if (value > min) {
//         setValue(value - 1);
//       }
//     };

//     // const displayText = `${value} ${value === 1 ? 'unit' : 'units'}`;
//     const displayText = `${value} ${t(
//       value === 1 ? "electrician.form.unit" : "electrician.form.units"
//     )}`;

//     return (
//       <div className="ElectricianService-plusMinusInput">
//         <button
//           type="button"
//           className="ElectricianService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="ElectricianService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="ElectricianService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="ElectricianService-container">
//         <Navbar />
//         <Loader show={loading} />
//         {/* Service Card */}
//         <div className="ElectricianService-card">
//           {/* Hero Section */}
//           <div className="ElectricianService-hero">
//             <img src={heroImage} alt="Electrician Services Hero" />
//           </div>

//           <div className="ElectricianService-header">
//             {/* <h1>Professional Electrician Services</h1> */}
//             {/* <h1>
//             {rebookState
//               ? "Rebook Electrician Service"
//               : "Professional Electrician Services"}
//           </h1> */}
//             <h1>
//               {rebookState
//                 ? t("electrician.header.rebook_title")
//                 : t("electrician.header.title")}
//             </h1>
//             {/* <div className="ElectricianService-rating">★★★★★</div>
//           <div className="ElectricianService-reviews">
//             82,708 Verified Reviews
//           </div> */}

//             <div className="ElectricianService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="ElectricianService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("electrician.reviewsLabel")}
//             </div>
//           </div>

//           {/* Categories / Info Blocks */}
//           <div className="ElectricianService-categories">
//             <div className="ElectricianService-category">
//               <h5>
//                 <span className="ElectricianService-categoryIcon">⚡</span>
//                 {/* Fan Services */}
//                 {t("electrician.categories.fan_services.title")}
//               </h5>
//               <p className="ElectricianService-serviceDescription">
//                 {/* Installation, replacement, or repair of ceiling fans and exhaust
//               fans. */}
//                 {t("electrician.categories.fan_services.description")}
//               </p>
//             </div>
//             <div className="ElectricianService-category">
//               <h5>
//                 <span className="ElectricianService-categoryIcon">💡</span>{" "}
//                 {/* Lighting Solutions */}
//                 {t("electrician.categories.lighting_solutions.title")}
//               </h5>
//               <p className="ElectricianService-serviceDescription">
//                 {/* Expert installation and repair of lighting fixtures, including
//               recessed and chandelier lights. */}
//                 {t("electrician.categories.lighting_solutions.description")}
//               </p>
//             </div>
//             <div className="ElectricianService-category">
//               <h5>
//                 <span className="ElectricianService-categoryIcon">🔌</span>{" "}
//                 {/* Electrical Panel Work */}
//                 {t("electrician.categories.electrical_panel_work.title")}
//               </h5>
//               <p className="ElectricianService-serviceDescription">
//                 {/* Servicing of distribution boards, circuit breakers, and
//               switchboards to ensure safety and efficiency. */}
//                 {t("electrician.categories.electrical_panel_work.description")}
//               </p>
//             </div>
//           </div>

//           {/* The Service Form */}
//           <form onSubmit={handleGetService} className="ElectricianService-form">
//             {/* Row 1: Fans & Regulators */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i class="fas fa-fan"></i>
//               {/* Fan Services */}
//               {t("electrician.form.fan_services_title")}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="fanInstall">
//                   {t("electrician.form.labels.fan_install")}
//                 </label> */}

//                 <label htmlFor="fanInstall" className="tooltip-label">
//                   {t("electrician.form.labels.fan_install")}
//                   <ServiceTooltip
//                     title={t("electrician.tooltips.fan_install.title") || "Fan Install/Uninstall"}
//                     description={t("electrician.tooltips.fan_install.description") || "If you need to install a new fan in a room, move it from one place to another, or uninstall an old one when shifting homes, this service ensures safe handling, proper wiring, and balance to prevent vibrations or electrical issues."}
//                   />
//                 </label>


//                 <PlusMinusInput
//                   id="fanInstall"
//                   value={fanInstall}
//                   setValue={setFanInstall}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="fanRepair">
//                   {t("electrician.form.labels.fan_repair")}
//                 </label> */}

//                 <label htmlFor="fanRepair" className="tooltip-label">
//                   {t("electrician.form.labels.fan_repair")}
//                   <ServiceTooltip
//                     title={t("electrician.tooltips.fan_repair.title") || "Fan Repair"}
//                     description={t("electrician.tooltips.fan_repair.description") || "Is your fan making noise, not spinning properly, or overheating? This service diagnoses problems like motor faults, blade imbalances, or capacitor issues, fixing them to restore smooth operation and energy efficiency while ensuring safety."}
//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="fanRepair"
//                   value={fanRepair}
//                   setValue={setFanRepair}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="regulatorInstall">
//                   {t("electrician.form.labels.regulator_install")}
//                 </label> */}

//                 <label htmlFor="regulatorInstall" className="tooltip-label">
//                   {t("electrician.form.labels.regulator_install")}
//                   <ServiceTooltip
//                     title={t("electrician.tooltips.regulator_install.title") || "Regulator Install/Uninstall"}
//                     description={t("electrician.tooltips.regulator_install.description") || "Need to add a speed controller for your fan or remove an old one during renovations? This service installs or uninstalls regulators with secure wiring, allowing precise speed control and preventing overloads in your electrical setup."}
//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="regulatorInstall"
//                   value={regulatorInstall}
//                   setValue={setRegulatorInstall}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="regulatorRepair">
//                   {t("electrician.form.labels.regulator_repair")}
//                 </label> */}

//                 <label htmlFor="regulatorRepair" className="tooltip-label">
//                   {t("electrician.form.labels.regulator_repair")}
//                   <ServiceTooltip
//                     title={t("electrician.tooltips.regulator_repair.title") || "Regulator Repair"}
//                     description={t("electrician.tooltips.regulator_repair.description") || "Fan speeds not changing or regulator sparking? We repair faulty switches, wiring, or electronics in regulators to avoid short circuits, ensuring reliable control and extending the life of your fan system."}
//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="regulatorRepair"
//                   value={regulatorRepair}
//                   setValue={setRegulatorRepair}
//                 />
//               </div>
//             </div>

//             {/* Row 2: Lights & Sockets */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i class="fas fa-lightbulb"></i>
//               {/* Lighting & Sockets */}
//               {t("electrician.form.lighting_sockets_title")}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="lightInstall">
//                   {t("electrician.form.labels.light_install")}
//                 </label> */}

//                 <label htmlFor="lightInstall" className="tooltip-label">
//     {t("electrician.form.labels.light_install")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.light_install.title") || "Light Install/Uninstall"}
//       description={t("electrician.tooltips.light_install.description") || "Setting up new ceiling lights, recessed fixtures, or chandeliers? Or removing old ones for redesigns? This service handles installation or uninstallation with precise wiring to ensure even lighting and no fire hazards from loose connections."}
//     />
//   </label>

//                 <PlusMinusInput
//                   id="lightInstall"
//                   value={lightInstall}
//                   setValue={setLightInstall}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="lightRepair">
//                   {t("electrician.form.labels.light_repair")}
//                 </label> */}
//                 <label htmlFor="lightRepair" className="tooltip-label">
//     {t("electrician.form.labels.light_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.light_repair.title") || "Light Repair"}
//       description={t("electrician.tooltips.light_repair.description") || "Lights flickering, buzzing, or failing to turn on? Our repair service checks bulbs, sockets, and circuits, fixing issues to provide consistent brightness and prevent energy waste or electrical faults."}
//     />
//   </label>

//                 <PlusMinusInput
//                   id="lightRepair"
//                   value={lightRepair}
//                   setValue={setLightRepair}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="socketInstall">
//                   {t("electrician.form.labels.socket_install")}
//                 </label> */}

//                 <label htmlFor="socketInstall" className="tooltip-label">
//     {t("electrician.form.labels.socket_install")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.socket_install.title") || "Socket Install/Uninstall"}
//       description={t("electrician.tooltips.socket_install.description") || "Running short on power outlets for chargers or appliances? Or removing outdated sockets? This service adds or removes sockets with grounded wiring, matching your home's load to avoid trips or shocks."}
//     />
//   </label>

//                 <PlusMinusInput
//                   id="socketInstall"
//                   value={socketInstall}
//                   setValue={setSocketInstall}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="socketRepair">
//                   {t("electrician.form.labels.socket_repair")}
//                 </label> */}

//                 <label htmlFor="socketRepair" className="tooltip-label">
//     {t("electrician.form.labels.socket_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.socket_repair.title") || "Socket Repair"}
//       description={t("electrician.tooltips.socket_repair.description") || "Plugs slipping out, sockets warm to touch, or sparking? We repair damaged outlets by tightening connections and replacing parts, ensuring safe power delivery and reducing fire risks."}
//     />
//   </label>

//                 <PlusMinusInput
//                   id="socketRepair"
//                   value={socketRepair}
//                   setValue={setSocketRepair}
//                 />
//               </div>
//             </div>

//             {/* Row 3: Panels & Breakers */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i class="fas fa-server"></i>
//               {/* Panels & Breakers */}
//               {t("electrician.form.panels_breakers_title")}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="switchBoardRepair">
//                   {t("electrician.form.labels.switch_board_repair")}
//                 </label> */}

//                 <label htmlFor="switchBoardRepair" className="tooltip-label">
//     {t("electrician.form.labels.switch_board_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.switch_board_repair.title") || "Switch Board Repair"}
//       description={t("electrician.tooltips.switch_board_repair.description") || "Switches loose, not clicking properly, or some rooms without power? This repair tightens components, replaces faulty switches, and checks wiring for seamless control of lights and appliances."}
//     />
//   </label>

//                 <PlusMinusInput
//                   id="switchBoardRepair"
//                   value={switchBoardRepair}
//                   setValue={setSwitchBoardRepair}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="mcbServicing">
//                   {t("electrician.form.labels.mcb_servicing")}
//                 </label> */}
//                 <label htmlFor="mcbServicing" className="tooltip-label">
//     {t("electrician.form.labels.mcb_servicing")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.mcb_servicing.title") || "MCB Servicing"}
//       description={t("electrician.tooltips.mcb_servicing.description") || "Frequent power trips from overloads? MCB servicing inspects and cleans Miniature Circuit Breakers, testing their trip mechanisms to protect circuits from shorts and surges effectively."}
//     />
//   </label>
//                 <PlusMinusInput
//                   id="mcbServicing"
//                   value={mcbServicing}
//                   setValue={setMcbServicing}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="mdbServicing">
//                   {t("electrician.form.labels.mdb_servicing")}
//                 </label> */}

//                 <label htmlFor="mdbServicing" className="tooltip-label">
//     {t("electrician.form.labels.mdb_servicing")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.mdb_servicing.title") || "MDB Servicing"}
//       description={t("electrician.tooltips.mdb_servicing.description") || "Main power board causing uneven supply or heating up? Servicing involves checking connections, labeling circuits, and load balancing to ensure stable electricity flow throughout your home."}
//     />
//   </label>

//                 <PlusMinusInput
//                   id="mdbServicing"
//                   value={distributionBoardServicing}
//                   setValue={setDistributionBoardServicing}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="breakerRepair">
//                   {t("electrician.form.labels.breaker_repair")}
//                 </label> */}

//                 <label htmlFor="breakerRepair" className="tooltip-label">
//     {t("electrician.form.labels.breaker_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.breaker_repair.title") || "Circuit Breaker Repair"}
//       description={t("electrician.tooltips.breaker_repair.description") || "Breakers not resetting or tripping randomly? We repair or replace them to handle high loads safely, preventing outages and protecting appliances from voltage spikes."}
//     />
//   </label>
//                 <PlusMinusInput
//                   id="breakerRepair"
//                   value={breakerRepair}
//                   setValue={setBreakerRepair}
//                 />
//               </div>
//             </div>

//             {/* <h3 className="ElectricianService-sectionTitle">
//               <i className="fas fa-bell"></i> Doorbell & Drilling
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 <label>Doorbell Setup</label>
//                 <PlusMinusInput value={doorbellSetup} setValue={setDoorbellSetup} />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 <label>Exhaust Fan Setup</label>
//                 <PlusMinusInput value={exhaustFanSetup} setValue={setExhaustFanSetup} />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 <label>Exhaust Fan Repair</label>
//                 <PlusMinusInput value={exhaustFanRepair} setValue={setExhaustFanRepair} />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 <label>Drill Wall Holes</label>
//                 <PlusMinusInput value={drillWallHoles} setValue={setDrillWallHoles} />
//               </div>
//             </div> */}

//             <h3 className="ElectricianService-sectionTitle">
//               <i className="fas fa-wrench"></i>{" "}
//               {t("electrician.form.doorbell_exhaust_drilling_title")}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 {/* <label>{t("electrician.form.labels.doorbell_setup")}</label> */}
//                 <label htmlFor="doorbellsetup" className="tooltip-label">
//     {t("electrician.form.labels.doorbell_setup")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.doorbell_setup.title") || "Doorbell Setup"}
//       description={t("electrician.tooltips.doorbell_setup.description") || "Installing a wired or wireless doorbell for better home alerts? This service wires the system, tests chimes, and integrates with existing power, enhancing security without complex setups."}
//     />
//   </label>
//                 <PlusMinusInput
//                   value={doorbellSetup}
//                   setValue={setDoorbellSetup}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label>{t("electrician.form.labels.exhaust_fan_setup")}</label> */}
//                 <label htmlFor="exhaustfansetup" className="tooltip-label">
//     {t("electrician.form.labels.exhaust_fan_setup")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.exhaust_fan_setup.title") || "Exhaust Fan Setup"}
//       description={t("electrician.tooltips.exhaust_fan_setup.description") || "Adding ventilation in kitchens or bathrooms to remove steam and smells? We install exhaust fans with ducting and switches, ensuring quiet operation and improved indoor air quality."}
//     />
//   </label>
//                 <PlusMinusInput
//                   value={exhaustFanSetup}
//                   setValue={setExhaustFanSetup}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label>{t("electrician.form.labels.exhaust_fan_repair")}</label> */}
//                 <label htmlFor="exhaustfanrepair" className="tooltip-label">
//     {t("electrician.form.labels.exhaust_fan_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.exhaust_fan_repair.title") || "Exhaust Fan Repair"}
//       description={t("electrician.tooltips.exhaust_fan_repair.description") || "Fan blades stuck or motor humming loudly? Repair cleans, lubricates, and fixes wiring in exhaust fans to restore airflow, reducing humidity and mold risks in your space."}
//     />
//   </label>
//                 <PlusMinusInput
//                   value={exhaustFanRepair}
//                   setValue={setExhaustFanRepair}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label>{t("electrician.form.labels.drill_wall_holes")}</label> */}
//                 <label htmlFor="drillwallholes" className="tooltip-label">
//     {t("electrician.form.labels.drill_wall_holes")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.drill_wall_holes.title") || "Drill Wall Holes"}
//       description={t("electrician.tooltips.drill_wall_holes.description") || "Mounting shelves, TVs, or AC units requires clean wall holes? We drill precisely with dust control and safety checks to avoid pipes or wires, making your installations sturdy and neat."}
//     />
//   </label>
//                 <PlusMinusInput
//                   value={drillWallHoles}
//                   setValue={setDrillWallHoles}
//                 />
//               </div>
//             </div>

//             {/* Row 4: Wiring & Checkup */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i class="fas fa-plug"></i>
//               {/* Wiring & Checkup */}
//               {t("electrician.form.wiring_checkup_title")}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="newWiringPoint">
//                   {t("electrician.form.labels.new_wiring_point")}
//                 </label> */}
//                 <label htmlFor="newWiringPoint" className="tooltip-label">
//     {t("electrician.form.labels.new_wiring_point")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.new_wiring_point.title") || "New Wiring Point"}
//       description={t("electrician.tooltips.new_wiring_point.description") || "Extending power to a new area like a home office or garage? This service runs concealed wiring safely, adding outlets or switches while complying with electrical codes to support your growing needs."}
//     />
//   </label>
//                 <PlusMinusInput
//                   id="newWiringPoint"
//                   value={newWiringPoint}
//                   setValue={setNewWiringPoint}
//                 />
//               </div>
//               {/* <div className="ElectricianService-optionGroup">
//               <label htmlFor="checkupPoints">Electrical Checkup (max 3)</label>
//               <PlusMinusInput
//                 id="checkupPoints"
//                 value={checkupPoints}
//                 setValue={setCheckupPoints}
//                 max={3}
//               />
//             </div> */}

//             {/* Coil Repair */}
//             <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="coilRepair">
//                   {t("electrician.form.labels.coil_repair", "Fan Coil Repair")}
//                 </label> */}
//                 <label htmlFor="coilRepair" className="tooltip-label">
//     {t("electrician.form.labels.coil_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.coil_repair.title") || "Fan Coil Repair"}
//       description={t("electrician.tooltips.coil_repair.description") || "Fan running hot or weak airflow due to burnt coils? Coil repair rewinds damaged copper windings in the motor, boosting efficiency and cooling without the cost of a full fan replacement."}
//     />
//   </label>
//                 <PlusMinusInput
//                   id="coilRepair"
//                   value={coilRepair}
//                   setValue={setCoilRepair}
//                 />
//               </div>


//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="needsCheckup">
//                   {t("electrician.form.labels.needs_checkup")}
//                 </label> */}

//                 <label htmlFor="needsCheckup" className="tooltip-label">
//     {t("electrician.form.labels.needs_checkup")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.needs_checkup.title") || "Electrical Checkup"}
//       description={t("electrician.tooltips.needs_checkup.description") || "Worried about hidden wiring issues or outdated setups? A full checkup scans your home's electrics for faults, overloads, or safety risks, providing a report with fixes to keep your family protected."}
//     />
//   </label>
//                 <select
//                   id="needsCheckup"
//                   value={needsCheckup ? "yes" : "no"}
//                   onChange={(e) => setNeedsCheckup(e.target.value === "yes")}
//                 >
//                   {/* <option value="no">Not Needed</option>
//                 <option value="yes">Need checkup</option> */}
//                   <option value="no">
//                     {t("electrician.form.labels.needs_checkup_options.no")}
//                   </option>{" "}
//                   {/* CHANGED: Added translation */}
//                   <option value="yes">
//                     {t("electrician.form.labels.needs_checkup_options.yes")}
//                   </option>{" "}
//                   {/* CHANGED: Added translation */}
//                 </select>
//               </div>

              


//               {/* Full Wiring */}
//               {/* <div className="ElectricianService-optionGroup">
//                 <label htmlFor="fullWiring">
//                   {t("electrician.form.labels.full_wiring")}
//                 </label>
//                 <select
//                   id="fullWiring"
//                   value={fullWiring ? "required" : "not-needed"}
//                   onChange={(e) => setFullWiring(e.target.value === "required")}
//                 >
//                   <option value="not-needed">
//                     {t(
//                       "electrician.form.labels.full_wiring_options.not_needed"
//                     )}
//                   </option>{" "}
//                   <option value="required">
//                     {t("electrician.form.labels.full_wiring_options.required")}
//                   </option>{" "}
//                 </select>
//               </div> */}
//             </div>

//             {/* New added for rebook same servitor */}

//             {/* {rebookState && (
//           <div className="rebook-same-servitor">
//             <label>
//               <input
//                 type="checkbox"
//                 checked={useSameServitor}
//                 onChange={() => setUseSameServitor(!useSameServitor)}
//               />
//               Booked same Servitor?
//             </label>
//           </div>
//         )} */}

//             {rebookState && prevServitorName && (
//               <div className="rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   {/* {t('electrician.form.rebook_same_servitor')} */}
//                   {/* {` Do you want to book ${prevServitorName} again?`} */}
//                   <span className="rebook-text">
//                     {t("electrician.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("electrician.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             {/* Price Display */}
//             <div className="ElectricianService-priceDisplay">
//               {/* <span>Estimated Price: {calculatePrice()} tk</span> */}
//               <span>
//                 {t("electrician.form.price_display", {
//                   price: calculatePrice(),
//                 })}
//               </span>
//               {/* <small>(Final price may vary based on complexity)</small> */}
//             </div>

//             {/* Pricing note banner */}
//             <div
//               className="ElectricianService-priceNote"
//               role="note"
//               aria-live="polite"
//             >
//               <div className="ElectricianService-priceNote-icon" aria-hidden="true">
//                 {/* small star icon (inline SVG so no extra imports) */}
//                 <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
//                   <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
//                 </svg>
//               </div>
//               <div className="ElectricianService-priceNote-content">
//                 <div className="ElectricianService-priceNote-title">
//                   {t("electrician.price_note.title")}
//                 </div>
//                 <p className="ElectricianService-priceNote-text">
//                   <strong>{t("electrician.price_note.service_charges_only_label")}</strong>{" "}
//                   {t("electrician.price_note.body")}
//                 </p>
//               </div>
//             </div>


//             {/* Booking Details */}
//             <div className="ElectricianService-bookingDetails">
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="date">
//                   {/* Preferred Date */}
//                   {t("electrician.form.labels.date")}
//                 </label>
//                 {/* <input type="date" id="date" name="date" min={todayDate} onChange={(e) => setSelectedDate(e.target.value)} required /> */}
//                 <div className="ElectricianService-dateInputWrapper">
//                   {/* DatePicker Input */}
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()} // blocks past dates
//                     // placeholderText="Select a date"
//                     placeholderText={t("electrician.form.labels.date")}
//                     className="ElectricianService-dateInput"
//                   />
//                   {/* Calendar Icon */}
//                   <FaCalendarAlt
//                     className="ElectricianService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(
//                           ".react-datepicker__input-container input"
//                         )
//                         .click()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="time">
//                   {/* Preferred Time */}
//                   {t("electrician.form.labels.time")}
//                 </label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* <h3 className="ElectricianService-sectionTitle">
//             <i className="fas fa-comment-alt"></i>
//             {t("electrician.form.remarks_title")}{" "}
//           </h3> */}
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup ElectricianService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("electrician.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("electrician.form.placeholders.remarks")}
//                   className="ElectricianService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             <button type="submit" className="ElectricianService-actionBtn">
//               {/* Book Service Now */}
//               {/* {rebookState ? "Confirm Rebooking" : "Book Service Now"} */}
//               {rebookState
//                 ? t("electrician.form.rebook_button")
//                 : t("electrician.form.book_button")}
//             </button>
//           </form>

//           <div className="ElectricianService-infoBox">
//             <h4>{t("electrician.info_box.title")}</h4>{" "}
//             {/* CHANGED: Added translation */}
//             <p>{t("electrician.info_box.description")}</p>{" "}
//             {/* CHANGED: Added translation */}
//           </div>

//           <div className="ElectricianService-additionalInfo">
//             <div className="ElectricianService-sectionCard">
//               <h2 className="ElectricianService-sectionTitle">
//                 {t("electrician.additional_info.how_to_place_order.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <ol className="ElectricianService-stepList">
//                 {t("electrician.additional_info.how_to_place_order.steps", {
//                   returnObjects: true,
//                 }).map(
//                   (step, idx /* CHANGED: Added translation for array */) => (
//                     <li key={idx}>{step}</li>
//                   )
//                 )}
//               </ol>
//             </div>

//             <div className="ElectricianService-row2col">
//               <div className="ElectricianService-sectionCard ElectricianService-gradientBg2">
//                 <h2 className="ElectricianService-sectionTitle">
//                   {t("electrician.additional_info.why_choose_HelpNao.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <p className="ElectricianService-sectionText">
//                   {t(
//                     "electrician.additional_info.why_choose_HelpNao.description"
//                   )}{" "}
//                   {/* CHANGED: Added translation */}
//                 </p>
//                 <div className="ElectricianService-featureGrid">
//                   {t("electrician.additional_info.why_choose_HelpNao.features", {
//                     returnObjects: true,
//                   }).map(
//                     (
//                       feature,
//                       idx /* CHANGED: Added translation for array */
//                     ) => (
//                       <div key={idx} className="ElectricianService-featureItem">
//                         <i
//                           className={`fas fa-${
//                             idx === 0
//                               ? "balance-scale"
//                               : idx === 1
//                               ? "user-shield"
//                               : idx === 2
//                               ? "mobile-alt"
//                               : "headset"
//                           } ElectricianService-featureIcon`}
//                           aria-hidden="true"
//                         ></i>
//                         <p>{feature}</p>
//                       </div>
//                     )
//                   )}
//                 </div>
//               </div>

//               <div className="ElectricianService-sectionCard ElectricianService-gradientBg">
//                 <h2 className="ElectricianService-sectionTitle">
//                   {t("electrician.additional_info.key_features.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <div className="ElectricianService-featureGrid">
//                   {t("electrician.additional_info.key_features.features", {
//                     returnObjects: true,
//                   }).map(
//                     (
//                       feature,
//                       idx /* CHANGED: Added translation for array */
//                     ) => (
//                       <div key={idx} className="ElectricianService-featureItem">
//                         <i
//                           className={`fas fa-${
//                             idx === 0
//                               ? "clock"
//                               : idx === 1
//                               ? "shield-alt"
//                               : idx === 2
//                               ? "check-circle"
//                               : idx === 3
//                               ? "shield-alt"
//                               : "credit-card"
//                           } ElectricianService-featureIcon`}
//                           aria-hidden="true"
//                         ></i>
//                         <p>{feature}</p>
//                       </div>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div className="ElectricianService-sectionCard">
//               <h2 className="ElectricianService-sectionTitle">
//                 {t("electrician.additional_info.mdb_mcb_service.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <div className="ElectricianService-mdbmcbGrid">
//                 <div className="ElectricianService-mdbmcbItem">
//                   <i
//                     className="fas fa-bolt ElectricianService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mdb.title"
//                       )}
//                     </h3>{" "}
//                     {/* CHANGED: Added translation */}
//                     <p>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mdb.description"
//                       )}
//                     </p>{" "}
//                     {/* CHANGED: Added translation */}
//                   </div>
//                 </div>
//                 <div className="ElectricianService-mdbmcbItem">
//                   <i
//                     className="fas fa-bolt ElectricianService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mcb.title"
//                       )}
//                     </h3>{" "}
//                     {/* CHANGED: Added translation */}
//                     <p>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mcb.description"
//                       )}
//                     </p>{" "}
//                     {/* CHANGED: Added translation */}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="ElectricianService-sectionCard ElectricianService-gradientBg3">
//               <h2 className="ElectricianService-sectionTitle">
//                 {t("electrician.additional_info.order_tracking.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <div className="ElectricianService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="ElectricianService-sectionText ElectricianService-centerText">
//                 {t("electrician.additional_info.order_tracking.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Order Form Modal */}
//         {showOrderForm && (
//           <ElectricianOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}

//         {/* Prompt Login Modal */}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>

//       {/* Add Feedback Section */}
//       <div className="electrician-feedback-section">
//         <FeedbackPage serviceType="Electrician" />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Electrician;











// ***** Update with new features and prices (22-Oct-2025) ***** //
// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";

// import ElectricianOrderForm from "./ElectricianOrderForm";
// import PromptLoginCard from "../PromptLoginCard";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import Footer from "../../../Components/Footer/Footer";

// import heroImage from "../images/Electric-service-banner.png";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import "./electricianStyle.css";
// import Loader from "../../../Components/LoaderSpin/Loader";
// import { ELECTRICIAN_PRICING } from "../servicePricing";
// import SEO from "../../../Components/SEO/SEO";

// const P = ELECTRICIAN_PRICING;
// const BASE_FEE = Number(P?.base ?? 0);
// const CHECKUP_FEE = Number(P?.checkupFlat ?? 0);

// const Electrician = () => {
//   const { t } = useTranslation();

//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });

//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false;
//   // const prevOrder   = location.state?.previousOrder || {};

//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   const [useSameServitor, setUseSameServitor] = useState(false); //new added for same servitor rebook
//   const [prevServitorName, setPrevServitorName] = useState(""); //new added for same servitor rebook

//   const [newCeilingFanInstallation, setNewCeilingFanInstallation] = useState(0);
//   const [ceilingFanInstallation, setCeilingFanInstallation] = useState(0);
//   const [ceilingFanUninstallation, setCeilingFanUninstallation] = useState(0);
//   const [fanCoilNewWinding, setFanCoilNewWinding] = useState(0);
//   const [fanCoilRepair, setFanCoilRepair] = useState(0);
//   const [capacitorSetup, setCapacitorSetup] = useState(0);

//   const [lightInstallation, setLightInstallation] = useState(0);
//   const [lightRepair, setLightRepair] = useState(0);

//   const [exhaustFanInstallation, setExhaustFanInstallation] = useState(0);
//   const [exhaustFanCleaning, setExhaustFanCleaning] = useState(0);

//   const [switchSetup, setSwitchSetup] = useState(0);
//   const [socketSetup, setSocketSetup] = useState(0);
//   const [regulatorSetup, setRegulatorSetup] = useState(0);

//   const [newWiringPoint, setNewWiringPoint] = useState(0);
//   const [mainCircuitBoardSetup, setMainCircuitBoardSetup] = useState(0);

//   const [doorbellInstallation, setDoorbellInstallation] = useState(0);
//   const [drillHoleService, setDrillHoleService] = useState(0);

//   const [ipsInstallationExistingLine, setIpsInstallationExistingLine] =
//     useState(0);
//   const [ipsNewLineInstallation, setIpsNewLineInstallation] = useState(0);

//   const [electricalCheckup, setElectricalCheckup] = useState(false);

//   const [remarks, setRemarks] = useState("");
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [loading, setLoading] = useState(false);

//   // const [selectedDate, setSelectedDate] = useState(new Date());


//   const toLocalYMD = (d) => {
//     const x = new Date(d);
//     const y = x.getFullYear();
//     const m = String(x.getMonth() + 1).padStart(2, "0");
//     const day = String(x.getDate()).padStart(2, "0");
//     return `${y}-${m}-${day}`;
//   };


//   // const getInitialDate = () => {
//   //   const now = new Date();
//   //   const currentHour = now.getHours();
//   //   // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//   //   if (currentHour < 7 || currentHour >= 21) {
//   //     const tomorrow = new Date();
//   //     tomorrow.setDate(now.getDate() + 1);
//   //     return tomorrow;
//   //   }
//   //   return now;
//   // };

//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();

//     // before 7am or after/equal 9pm -> tomorrow
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date(now);
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };


//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   // const [selectedTime, setSelectedTime]   = useState('');

//   useEffect(() => {
//     if (rebookState) {
//       setNewCeilingFanInstallation(prevOrder.new_ceiling_fan_installation || 0);
//       setCeilingFanInstallation(prevOrder.ceiling_fan_installation || 0);
//       setCeilingFanUninstallation(prevOrder.ceiling_fan_uninstallation || 0);
//       setFanCoilNewWinding(prevOrder.fan_coil_new_winding || 0);
//       setFanCoilRepair(prevOrder.fan_coil_repair || 0);
//       setCapacitorSetup(prevOrder.capacitor_setup || 0);

//       setLightInstallation(prevOrder.light_installation || 0);
//       setLightRepair(prevOrder.light_repair || 0);

//       setExhaustFanInstallation(prevOrder.exhaust_fan_installation || 0);
//       setExhaustFanCleaning(prevOrder.exhaust_fan_cleaning || 0);

//       setSwitchSetup(prevOrder.switch_setup || 0);
//       setSocketSetup(prevOrder.socket_setup || 0);
//       setRegulatorSetup(prevOrder.regulator_setup || 0);

//       setNewWiringPoint(prevOrder.new_wiring_point || 0);
//       setMainCircuitBoardSetup(prevOrder.main_circuit_board_setup || 0);

//       setDoorbellInstallation(prevOrder.doorbell_installation || 0);
//       setDrillHoleService(prevOrder.drill_hole_service || 0);

//       setIpsInstallationExistingLine(
//         prevOrder.ips_installation_existing_line || 0
//       );
//       setIpsNewLineInstallation(prevOrder.ips_new_line_installation || 0);

//       setElectricalCheckup(!!prevOrder.Electrical_checkup);
//     }
//   }, [rebookState, prevOrder]);

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id;
//           const extractedUserId = userId.startsWith("user-")
//             ? userId.split("user-")[1]
//             : userId;

//           const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   //new added for same servitor rebook
//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch((err) => console.error("Error fetching servitor:", err));
//     }
//   }, [rebookState, prevOrder.servitor_id]);


//   useEffect(() => {
//     const loadRatings = async () => {
//       try {
//         setLoading(true);
//         const { data } = await axios.get(`${URL}/api/ratings`);
//         const { electrician = {} } = data;
//         setRatingData({
//           reviewCount: electrician.reviewCount || 0,
//           avgRating: electrician.avgRating || 0,
//         });
//       } catch (err) {
//         console.error("Failed to load ratings:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     loadRatings();
//   }, []);

//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     // const todayStr = now.toISOString().split("T")[0];
//     // const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     const todayStr = toLocalYMD(now);
//     const selectedDateStr = dateObj ? toLocalYMD(dateObj) : "";


//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Price Calculate & breakdown
//   // ---------- Pricing helpers ----------
//   const U = (v) => Math.max(0, Number(v) || 0);
//   const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;
//   // const unit = (key) => Number(P?.perUnit?.[key] ?? 0);

//   // ***** Update for drill holes ***** //
//   const getRate = useCallback((key) => P?.perUnit?.[key] ?? 0, []);

//   const unit = useCallback((key) => {
//     const r = getRate(key);
//     return typeof r === "number" ? Number(r) : 0;
//   }, [getRate]);

//   // supports both number and { first, additional }
//   const lineTotal = useCallback((key, count) => {
//     const c = U(count);
//     if (!c) return 0;

//     const r = getRate(key);

//     if (typeof r === "number") return c * r;

//     const first = Number(r.first ?? 0);
//     const add = Number(r.additional ?? r.first ?? 0);
//     return first + Math.max(0, c - 1) * add;
//   }, [getRate]);


//   const drillRate = useMemo(() => getRate("drill_hole_service"), [getRate]);

//   const DRILL_FIRST = useMemo(() => (
//     typeof drillRate === "object" ? Number(drillRate?.first ?? 0) : Number(drillRate ?? 0)
//   ), [drillRate]);

//   const DRILL_PER_HOLE = useMemo(() => (
//     typeof drillRate === "object" ? Number(drillRate?.additional ?? 0) : 0
//   ), [drillRate]);


//   // ── TRUE when ANY service selected (counts > 0) or checkup chosen
//   const hasAnySelection = useMemo(() => {
//     const counts = [
//       newCeilingFanInstallation,
//       ceilingFanInstallation,
//       ceilingFanUninstallation,
//       fanCoilNewWinding,
//       fanCoilRepair,
//       capacitorSetup,
//       lightInstallation,
//       lightRepair,
//       exhaustFanInstallation,
//       exhaustFanCleaning,
//       switchSetup,
//       socketSetup,
//       regulatorSetup,
//       newWiringPoint,
//       mainCircuitBoardSetup,
//       doorbellInstallation,
//       drillHoleService,
//       ipsInstallationExistingLine,
//       ipsNewLineInstallation,
//     ];
//     return counts.some((c) => U(c) > 0) || !!electricalCheckup;
//   }, [
//     newCeilingFanInstallation,
//     ceilingFanInstallation,
//     ceilingFanUninstallation,
//     fanCoilNewWinding,
//     fanCoilRepair,
//     capacitorSetup,
//     lightInstallation,
//     lightRepair,
//     exhaustFanInstallation,
//     exhaustFanCleaning,
//     switchSetup,
//     socketSetup,
//     regulatorSetup,
//     newWiringPoint,
//     mainCircuitBoardSetup,
//     doorbellInstallation,
//     drillHoleService,
//     ipsInstallationExistingLine,
//     ipsNewLineInstallation,
//     electricalCheckup,
//   ]);

//   // ---------- Total price ----------
//   const calculatePrice = () => {
//     let price = 0;

//     // Base/booking fee only when something is selected
//     if (hasAnySelection) {
//       price += BASE_FEE;
//     }

//     // Per-unit lines
//     price += U(newCeilingFanInstallation) * unit("new_ceiling_fan_installation");
//     price += U(ceilingFanInstallation) * unit("ceiling_fan_installation");
//     price += U(ceilingFanUninstallation) * unit("ceiling_fan_uninstallation");
//     price += U(fanCoilNewWinding) * unit("fan_coil_new_winding");
//     price += U(fanCoilRepair) * unit("fan_coil_repair");
//     price += U(capacitorSetup) * unit("capacitor_setup");

//     price += U(lightInstallation) * unit("light_installation");
//     price += U(lightRepair) * unit("light_repair");

//     price += U(exhaustFanInstallation) * unit("exhaust_fan_installation");
//     price += U(exhaustFanCleaning) * unit("exhaust_fan_cleaning");

//     price += U(switchSetup) * unit("switch_setup");
//     price += U(socketSetup) * unit("socket_setup");
//     price += U(regulatorSetup) * unit("regulator_setup");

//     price += U(newWiringPoint) * unit("new_wiring_point");
//     price += U(mainCircuitBoardSetup) * unit("main_circuit_board_setup");

//     price += U(doorbellInstallation) * unit("doorbell_installation");
//     // price += U(drillHoleService) * unit("drill_hole_service");
//     price += lineTotal("drill_hole_service", drillHoleService);


//     price +=
//       U(ipsInstallationExistingLine) * unit("ips_installation_existing_line");
//     price += U(ipsNewLineInstallation) * unit("ips_new_line_installation");

//     // Flat electrical checkup (boolean)
//     if (electricalCheckup) {
//       price += CHECKUP_FEE;
//     }

//     return Math.round(price);
//   };

//   // ---------- Breakdown rows (AC-style) ----------
//   const breakdownRows = useMemo(() => {
//     const rows = [];
//     const add = (label, count, key) => {
//       const c = U(count);
//       if (!c) return;

//       const r = getRate(key);

//       // normal numeric pricing
//       if (typeof r === "number") {
//         rows.push({
//           label,
//           calc: `${c} × ${fmtTk(r)} =`,
//           total: fmtTk(c * r),
//         });
//         return;
//       }

//       // {first, additional} pricing (drill holes)
//       const first = Number(r.first ?? 0);
//       const additional = Number(r.additional ?? 0);

//       if (c === 1) {
//         rows.push({
//           label,
//           calc: `${fmtTk(first)} =`,
//           total: fmtTk(first),
//         });
//       } else {
//         rows.push({
//           label,
//           calc: `${fmtTk(first)} + ${c - 1} × ${fmtTk(additional)} =`,
//           total: fmtTk(first + (c - 1) * additional),
//         });
//       }
//     };


//     // Fan & Coil
//     add(
//       t(
//         "electrician.breakdown.new_ceiling_fan_installation",
//         "New Ceiling Fan Installation"
//       ),
//       newCeilingFanInstallation,
//       "new_ceiling_fan_installation"
//     );

//     add(
//       t(
//         "electrician.breakdown.ceiling_fan_install",
//         "Ceiling Fan Installation"
//       ),
//       ceilingFanInstallation,
//       "ceiling_fan_installation"
//     );
//     add(
//       t(
//         "electrician.breakdown.ceiling_fan_uninstall",
//         "Ceiling Fan Uninstallation"
//       ),
//       ceilingFanUninstallation,
//       "ceiling_fan_uninstallation"
//     );
//     add(
//       t("electrician.breakdown.fan_coil_new_winding", "Fan Coil New Winding"),
//       fanCoilNewWinding,
//       "fan_coil_new_winding"
//     );
//     add(
//       t("electrician.breakdown.fan_coil_repair", "Fan Coil Repair"),
//       fanCoilRepair,
//       "fan_coil_repair"
//     );
//     add(
//       t("electrician.breakdown.capacitor_setup", "Capacitor Setup"),
//       capacitorSetup,
//       "capacitor_setup"
//     );

//     // Light & Exhaust
//     add(
//       t("electrician.breakdown.light_install", "Light Installation"),
//       lightInstallation,
//       "light_installation"
//     );
//     add(
//       t("electrician.breakdown.light_repair", "Light Repair"),
//       lightRepair,
//       "light_repair"
//     );
//     add(
//       t(
//         "electrician.breakdown.exhaust_fan_install",
//         "Exhaust Fan Installation"
//       ),
//       exhaustFanInstallation,
//       "exhaust_fan_installation"
//     );
//     add(
//       t("electrician.breakdown.exhaust_fan_clean", "Exhaust Fan Cleaning"),
//       exhaustFanCleaning,
//       "exhaust_fan_cleaning"
//     );

//     // Switch • Socket • Regulator
//     add(
//       t("electrician.breakdown.switch_setup", "Switch Setup"),
//       switchSetup,
//       "switch_setup"
//     );
//     add(
//       t("electrician.breakdown.socket_setup", "Socket Setup"),
//       socketSetup,
//       "socket_setup"
//     );
//     add(
//       t("electrician.breakdown.regulator_setup", "Regulator Setup"),
//       regulatorSetup,
//       "regulator_setup"
//     );

//     // Wiring & Boards
//     add(
//       t("electrician.breakdown.new_wiring_point", "New Wiring Point"),
//       newWiringPoint,
//       "new_wiring_point"
//     );
//     add(
//       t(
//         "electrician.breakdown.main_circuit_board_setup",
//         "Main Circuit Board Setup"
//       ),
//       mainCircuitBoardSetup,
//       "main_circuit_board_setup"
//     );

//     // Doorbell • Drilling • IPS
//     add(
//       t("electrician.breakdown.doorbell_install", "Doorbell Installation"),
//       doorbellInstallation,
//       "doorbell_installation"
//     );
//     add(
//       t("electrician.breakdown.drill_hole_service", "Drill Hole Service"),
//       drillHoleService,
//       "drill_hole_service"
//     );
//     add(
//       t(
//         "electrician.breakdown.ips_existing",
//         "IPS Installation (Existing Line)"
//       ),
//       ipsInstallationExistingLine,
//       "ips_installation_existing_line"
//     );
//     add(
//       t("electrician.breakdown.ips_new_line", "IPS New Line Installation"),
//       ipsNewLineInstallation,
//       "ips_new_line_installation"
//     );

//     // ✅ Flat electrical checkup (only when chosen)
//     if (electricalCheckup) {
//       rows.push({
//         label: t(
//           "electrician.breakdown.electrical_checkup",
//           "Electrical Checkup"
//         ),
//         calc: "", // flat, no "×"
//         total: fmtTk(CHECKUP_FEE),
//       });
//     }

//     // ✅ Booking fee only when there is at least ONE line above
//     if (rows.length > 0 && BASE_FEE > 0) {
//       rows.push({
//         // label: t("electrician.breakdown.booking_fee", "Booking Fee"),
//         label: t("electrician.breakdown.platform_support_fee", "Platform & Support Fee"),
//         calc: "",
//         total: fmtTk(BASE_FEE),
//       });
//     }

//     return rows;
//   }, [
//     t,
//     newCeilingFanInstallation,
//     ceilingFanInstallation,
//     ceilingFanUninstallation,
//     fanCoilNewWinding,
//     fanCoilRepair,
//     capacitorSetup,
//     lightInstallation,
//     lightRepair,
//     exhaustFanInstallation,
//     exhaustFanCleaning,
//     switchSetup,
//     socketSetup,
//     regulatorSetup,
//     newWiringPoint,
//     mainCircuitBoardSetup,
//     doorbellInstallation,
//     drillHoleService,
//     ipsInstallationExistingLine,
//     ipsNewLineInstallation,
//     electricalCheckup, // important so the row appears/disappears
//     getRate,
//   ]);

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();

//     if (!hasAnySelection) return;

//     // const date = e.target.date.value;
//     const time = e.target.time.value;
//     // setSelectedDate(date);
//     let dateStr = "";
//     if (selectedDate) {
//       // dateStr = selectedDate.toISOString().split("T")[0];
//       dateStr = toLocalYMD(selectedDate);
//     }

//     const formDetails = {
//       new_ceiling_fan_installation: newCeilingFanInstallation,
//       ceiling_fan_installation: ceilingFanInstallation,
//       ceiling_fan_uninstallation: ceilingFanUninstallation,
//       fan_coil_new_winding: fanCoilNewWinding,
//       fan_coil_repair: fanCoilRepair,
//       capacitor_setup: capacitorSetup,

//       light_installation: lightInstallation,
//       light_repair: lightRepair,

//       exhaust_fan_installation: exhaustFanInstallation,
//       exhaust_fan_cleaning: exhaustFanCleaning,

//       switch_setup: switchSetup,
//       socket_setup: socketSetup,
//       regulator_setup: regulatorSetup,

//       new_wiring_point: newWiringPoint,
//       main_circuit_board_setup: mainCircuitBoardSetup,

//       doorbell_installation: doorbellInstallation,
//       drill_hole_service: drillHoleService,

//       ips_installation_existing_line: ipsInstallationExistingLine,
//       ips_new_line_installation: ipsNewLineInstallation,

//       Electrical_checkup: electricalCheckup,

//       remarks,

//       price: calculatePrice(),
//       // date,
//       date: dateStr,
//       time,

//       // new added for rebook same servitor
//       useSameServitor,
//       servitor_id: useSameServitor
//         ? prevOrder.servitor_id // carry through the original servitor’s ID
//         : undefined,
//     };
//     setFormData(formDetails);

//     // If user is logged in, show the order form; otherwise prompt for login
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // Once user confirms the order in ElectricianOrderForm
//   const handleOrderSubmit = (orderData) => {
//     // console.log("Order Data:", orderData);
//     setShowOrderForm(false);

//     // 2) Reset _every_ form‐state back to its initial “empty” value:
//     setNewCeilingFanInstallation(0);
//     setCeilingFanInstallation(0);
//     setCeilingFanUninstallation(0);
//     setFanCoilNewWinding(0);
//     setFanCoilRepair(0);
//     setCapacitorSetup(0);

//     setLightInstallation(0);
//     setLightRepair(0);

//     setExhaustFanInstallation(0);
//     setExhaustFanCleaning(0);

//     setSwitchSetup(0);
//     setSocketSetup(0);
//     setRegulatorSetup(0);

//     setNewWiringPoint(0);
//     setMainCircuitBoardSetup(0);

//     setDoorbellInstallation(0);
//     setDrillHoleService(0);

//     setIpsInstallationExistingLine(0);
//     setIpsNewLineInstallation(0);

//     setElectricalCheckup(false);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData({});
//   };

//   // Get today's date in YYYY-MM-DD format for the min attribute
//   // const todayDate = new Date().toISOString().split('T')[0];

//   // const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//   //   const { t } = useTranslation();
//   //   const handleIncrement = () => {
//   //     if (value < max) {
//   //       setValue(value + 1);
//   //     }
//   //   };

//   //   const handleDecrement = () => {
//   //     if (value > min) {
//   //       setValue(value - 1);
//   //     }
//   //   };

//   //   // const displayText = `${value} ${value === 1 ? 'unit' : 'units'}`;
//   //   const displayText = `${value} ${t(
//   //     value === 1 ? "electrician.form.unit" : "electrician.form.units"
//   //   )}`;

//   //   return (
//   //     <div className="ElectricianService-plusMinusInput">
//   //       <button
//   //         type="button"
//   //         className="ElectricianService-minusBtn"
//   //         onClick={handleDecrement}
//   //         disabled={value <= min}
//   //       >
//   //         −
//   //       </button>
//   //       <span className="ElectricianService-valueDisplay">{displayText}</span>
//   //       <button
//   //         type="button"
//   //         className="ElectricianService-plusBtn"
//   //         onClick={handleIncrement}
//   //         disabled={value >= max}
//   //       >
//   //         +
//   //       </button>
//   //     </div>
//   //   );
//   // };

//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const { t } = useTranslation();
//     const inc = () => value < max && setValue(value + 1);
//     const dec = () => value > min && setValue(value - 1);
//     const display = `${value} ${t(
//       value === 1 ? "electrician.form.unit" : "electrician.form.units"
//     )}`;
//     return (
//       <div className="ElectricianService-plusMinusInput">
//         <button
//           type="button"
//           className="ElectricianService-minusBtn"
//           onClick={dec}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="ElectricianService-valueDisplay">{display}</span>
//         <button
//           type="button"
//           className="ElectricianService-plusBtn"
//           onClick={inc}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="ElectricianService-container">
//         <SEO
//           title="Electrician Service in Bangladesh | HelpNao"
//           description="Book trusted electricians for wiring, fan/light repair, sockets, switch issues, and emergency fixes. Fast service, verified professionals."
//           path="/services/electrician"
//           lang="en"
//           jsonLd={{
//             "@context": "https://schema.org",
//             "@type": "Service",
//             "name": "Electrician Service",
//             "provider": { "@type": "Organization", "name": "HelpNao" },
//             "areaServed": "Dhaka, Bangladesh",
//             "serviceType": "Electrician"
//           }}
//         />

//         <Navbar />
//         <Loader show={loading} />
//         {/* Service Card */}
//         <div className="ElectricianService-card">
//           {/* Hero Section */}
//           <div className="ElectricianService-hero">
//             <img src={heroImage} alt="Electrician Services Hero" />
//           </div>

//           <div className="ElectricianService-header">
//             {/* <h1>Professional Electrician Services</h1> */}
//             {/* <h1>
//             {rebookState
//               ? "Rebook Electrician Service"
//               : "Professional Electrician Services"}
//           </h1> */}
//             <h1>
//               {rebookState
//                 ? t("electrician.header.rebook_title")
//                 : t("electrician.header.title")}
//             </h1>
//             {/* <div className="ElectricianService-rating">★★★★★</div>
//           <div className="ElectricianService-reviews">
//             82,708 Verified Reviews
//           </div> */}

//             <div className="ElectricianService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="ElectricianService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("electrician.reviewsLabel")}
//             </div>
//           </div>

//           {/* The Service Form */}
//           <form onSubmit={handleGetService} className="ElectricianService-form">
//             {/* Row 1: Fans & Regulators */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i className="fas fa-fan"></i>{" "}
//               {t("electrician.form.fan_services_title") || "Fan Services"}
//             </h3>
//             <div className="ElectricianService-serviceOptions">


//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="newCeilingFanInstall" className="tooltip-label">
//                   {t("electrician.form.labels.new_ceiling_fan_installation") ||
//                     "New Ceiling Fan Installation"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.new_ceiling_fan_installation.title") ||
//                       "New Ceiling Fan Installation (with fresh mount/wiring)"
//                     }
//                     description={
//                       t("electrician.tooltips.new_ceiling_fan_installation.description", {
//                         price: unit("new_ceiling_fan_installation"),
//                       })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="ncfi"
//                   value={newCeilingFanInstallation}
//                   setValue={setNewCeilingFanInstallation}
//                 />
//               </div>

//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="fanInstall" className="tooltip-label">
//                   {/* Ceiling Fan Installation */}
//                   {t("electrician.form.labels.ceiling_fan_installation") ||
//                     "Ceiling Fan Installation"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.fan_install.title") ||
//                       "Ceiling/Wall Fan Installation"
//                     }
//                     description={t("electrician.tooltips.fan_install.description", {
//                       price: unit("ceiling_fan_installation"),
//                     })}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="cfi"
//                   value={ceilingFanInstallation}
//                   setValue={setCeilingFanInstallation}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="fanRepair" className="tooltip-label">
//                   {/* Ceiling Fan Uninstallation */}
//                   {t("electrician.form.labels.ceiling_fan_uninstallation") ||
//                     "Ceiling Fan Uninstallation"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.fan_uninstall.title") ||
//                       "Ceiling Fan Uninstallation"
//                     }
//                     description={t("electrician.tooltips.fan_uninstall.description", {
//                       price: unit("ceiling_fan_uninstallation"),
//                     })}

//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="cfu"
//                   value={ceilingFanUninstallation}
//                   setValue={setCeilingFanUninstallation}
//                 />
//               </div>
//             </div>

//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="fancoilSetup" className="tooltip-label">
//                   {/* Fan Coil New Winding */}
//                   {t("electrician.form.labels.fan_coil_new_winding") ||
//                     "Fan Coil New Winding"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.fan_coil_new_winding.title") ||
//                       "Fan Coil New Winding"
//                     }
//                     description={t("electrician.tooltips.fan_coil_new_winding.description", {
//                       price: unit("fan_coil_new_winding"),
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="fcnw"
//                   value={fanCoilNewWinding}
//                   setValue={setFanCoilNewWinding}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">

//                 <label htmlFor="fancoilRepair" className="tooltip-label">
//                   {/* Fan Coil Repair */}
//                   {t("electrician.form.labels.fan_coil_repair") ||
//                     "Fan Coil Repair"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.coil_repair.title") ||
//                       "Fan Coil Repair"
//                     }
//                     description={t("electrician.tooltips.coil_repair.description", {
//                       price: unit("fan_coil_repair"),
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="fcr"
//                   value={fanCoilRepair}
//                   setValue={setFanCoilRepair}
//                 />
//               </div>

//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="capacitorsetup" className="tooltip-label">
//                   {/* Capacitor Setup */}
//                   {t("electrician.form.labels.capacitor_setup") ||
//                     "Capacitor Setup"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.capacitor_setup.title") ||
//                       "Fan Capacitor Setup/Replacement"
//                     }
//                     description={t("electrician.tooltips.capacitor_setup.description", {
//                       price: unit("capacitor_setup"),
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="caps"
//                   value={capacitorSetup}
//                   setValue={setCapacitorSetup}
//                 />
//               </div>
//             </div>

//             {/* Row 2: Lights & Sockets */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i className="fas fa-lightbulb"></i>{" "}
//               {t("electrician.form.lighting_sockets_title") ||
//                 "Light & Exhaust Fan"}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="lightInstall" className="tooltip-label">
//                   {t("electrician.form.labels.light_install") ||
//                     "Light Install"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.light_install.title") ||
//                       "Light Install/Uninstall"
//                     }
//                     description={t("electrician.tooltips.light_install.description", {
//                       price: unit("light_installation"),
//                     })}

//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="li"
//                   value={lightInstallation}
//                   setValue={setLightInstallation}
//                 />
//               </div>
//               {/* <div className="ElectricianService-optionGroup">
//                 <label htmlFor="lightRepair" className="tooltip-label">
//                   {t("electrician.form.labels.light_repair") || "Light Repair"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.light_repair.title") ||
//                       "Light Repair"
//                     }
//                     description={t(
//                       "electrician.tooltips.light_repair.description"
//                     )}
//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="lr"
//                   value={lightRepair}
//                   setValue={setLightRepair}
//                 />
//               </div> */}

//               <div className="ElectricianService-optionGroup">

//                 <label htmlFor="socketInstall" className="tooltip-label">
//                   {/* Exhaust Fan Installation */}
//                   {t("electrician.form.labels.exhaust_fan_installation") ||
//                     "Exhaust Fan Installation"}
//                   <ServiceTooltip
//                     title={
//                       t(
//                         "electrician.tooltips.exhaust_fan_installation.title"
//                       ) || "Exhaust Fan Installation"
//                     }
//                     description={t("electrician.tooltips.exhaust_fan_installation.description", {
//                       price: unit("exhaust_fan_installation"),
//                     })}

//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="efi"
//                   value={exhaustFanInstallation}
//                   setValue={setExhaustFanInstallation}
//                 />
//               </div>
//               {/* <div className="ElectricianService-optionGroup">
//                 <label htmlFor="socketRepair" className="tooltip-label">
//                   {t("electrician.form.labels.exhaust_fan_cleaning") ||
//                     "Exhaust Fan Cleaning"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.exhaust_fan_cleaning.title") ||
//                       "Exhaust Fan Cleaning"
//                     }
//                     description={t(
//                       "electrician.tooltips.exhaust_fan_cleaning.description"
//                     )}
//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="efc"
//                   value={exhaustFanCleaning}
//                   setValue={setExhaustFanCleaning}
//                 />
//               </div> */}
//             </div>

//             {/* Row 3: Panels & Breakers */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i className="fas fa-toggle-on"></i>{" "}
//               {t("electrician.form.panels_breakers_title") ||
//                 "Switch • Socket • Regulator"}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">

//                 <label htmlFor="switchBoardRepair" className="tooltip-label">
//                   {/* Switch Setup */}
//                   {t("electrician.form.labels.switch_setup") || "Switch Setup"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.switch_setup.title") ||
//                       "Switch Setup"
//                     }
//                     description={t("electrician.tooltips.switch_setup.description", {
//                       price: unit("switch_setup"),
//                     })}

//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="sw"
//                   value={switchSetup}
//                   setValue={setSwitchSetup}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="mcbServicing">
//                   {t("electrician.form.labels.mcb_servicing")}
//                 </label> */}
//                 <label htmlFor="mcbServicing" className="tooltip-label">
//                   {/* Socket Setup */}
//                   {t("electrician.form.labels.socket_setup") || "Socket Setup"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.socket_setup.title") ||
//                       "Socket Setup"
//                     }
//                     description={t("electrician.tooltips.socket_setup.description", {
//                       price: unit("socket_setup"),
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="so"
//                   value={socketSetup}
//                   setValue={setSocketSetup}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="mdbServicing">
//                   {t("electrician.form.labels.mdb_servicing")}
//                 </label> */}

//                 <label htmlFor="mdbServicing" className="tooltip-label">
//                   {/* Regulator Setup */}
//                   {t("electrician.form.labels.regulator_setup") ||
//                     "Regulator Setup"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.regulator_setup.title") ||
//                       "Fan Regulator Setup"
//                     }
//                     description={t("electrician.tooltips.regulator_setup.description", {
//                       price: unit("regulator_setup"),
//                     })}

//                   />
//                 </label>

//                 <PlusMinusInput
//                   id="reg"
//                   value={regulatorSetup}
//                   setValue={setRegulatorSetup}
//                 />
//               </div>
//               {/* <div className="ElectricianService-optionGroup">
//                 <label htmlFor="breakerRepair" className="tooltip-label">
//     {t("electrician.form.labels.breaker_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.breaker_repair.title") || "Circuit Breaker Repair"}
//       description={t("electrician.tooltips.breaker_repair.description") || "Breakers not resetting or tripping randomly? We repair or replace them to handle high loads safely, preventing outages and protecting appliances from voltage spikes."}
//     />
//   </label>
//                 <PlusMinusInput
//                   id="breakerRepair"
//                   value={breakerRepair}
//                   setValue={setBreakerRepair}
//                 />
//               </div> */}
//             </div>

//             {/* Row 4: Wiring & Checkup */}
//             <h3 className="ElectricianService-sectionTitle">
//               <i className="fas fa-toolbox"></i>
//               {/* Doorbell • Drilling • IPS */}
//               {t("electrician.form.doorbell_exhaust_drilling_title") ||
//                 "Doorbell • Drilling • IPS"}
//             </h3>

//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="newWiringPoint">
//                   {t("electrician.form.labels.new_wiring_point")}
//                 </label> */}
//                 <label htmlFor="newWiringPoint" className="tooltip-label">
//                   {/* Doorbell Installation */}
//                   {t("electrician.form.labels.doorbell_installation") ||
//                     "Doorbell Installation"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.doorbell_setup.title") ||
//                       "Doorbell Setup (Wired/Wireless)"
//                     }
//                     description={t("electrician.tooltips.doorbell_setup.description", {
//                       price: unit("doorbell_installation"),
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="db"
//                   value={doorbellInstallation}
//                   setValue={setDoorbellInstallation}
//                 />
//               </div>

//               {/* Coil Repair */}
//               <div className="ElectricianService-optionGroup">
//                 {/* <label htmlFor="coilRepair">
//                   {t("electrician.form.labels.coil_repair", "Fan Coil Repair")}
//                 </label> */}
//                 <label htmlFor="coilRepair" className="tooltip-label">
//                   {/* Drill Hole Service */}
//                   {t("electrician.form.labels.drill_hole_service") ||
//                     " Drill Hole Service"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.drill_wall_holes.title") ||
//                       "Drill Wall Holes"
//                     }
//                     description={t("electrician.tooltips.drill_wall_holes.description", {
//                       first: DRILL_FIRST,
//                       perHole: DRILL_PER_HOLE,
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="drill"
//                   value={drillHoleService}
//                   setValue={setDrillHoleService}
//                 />
//               </div>

//               {/* <div className="ElectricianService-optionGroup">
//                 <label htmlFor="ipsSetupLine" className="tooltip-label">
//                   {t(
//                     "electrician.form.labels.ips_installation_existing_line"
//                   ) || "IPS Setup (Existing Line)"}
//                   <ServiceTooltip
//                     title={
//                       t(
//                         "electrician.tooltips.ips_install_existing_line.title"
//                       ) || "IPS Installation (Existing Line)"
//                     }
//                     description={t(
//                       "electrician.tooltips.ips_install_existing_line.description"
//                     )}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="ips1"
//                   value={ipsInstallationExistingLine}
//                   setValue={setIpsInstallationExistingLine}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="ipsSetupNewLine" className="tooltip-label">
//                   {t("electrician.form.labels.ips_new_line_installation") ||
//                     "IPS Setup (New Line)"}
//                   <ServiceTooltip
//                     title={
//                       t(
//                         "electrician.tooltips.ips_new_line_installation.title"
//                       ) || "IPS New Line Installation"
//                     }
//                     description={t(
//                       "electrician.tooltips.ips_new_line_installation.description"
//                     )}
//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="ips2"
//                   value={ipsNewLineInstallation}
//                   setValue={setIpsNewLineInstallation}
//                 />
//               </div> */}



//               {/* <div className="ElectricianService-optionGroup">

//                 <label htmlFor="needsCheckup" className="tooltip-label">
//     {t("electrician.form.labels.needs_checkup")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.needs_checkup.title") || "Electrical Checkup"}
//       description={t("electrician.tooltips.needs_checkup.description") || "Worried about hidden wiring issues or outdated setups? A full checkup scans your home's electrics for faults, overloads, or safety risks, providing a report with fixes to keep your family protected."}
//     />
//   </label>
//                 <select
//                   id="needsCheckup"
//                   value={needsCheckup ? "yes" : "no"}
//                   onChange={(e) => setNeedsCheckup(e.target.value === "yes")}
//                 >
//                   <option value="no">
//                     {t("electrician.form.labels.needs_checkup_options.no")}
//                   </option>{" "}
//                   <option value="yes">
//                     {t("electrician.form.labels.needs_checkup_options.yes")}
//                   </option>{" "}
//                 </select>
//               </div> */}
//             </div>

//             <h3 className="ElectricianService-sectionTitle">
//               <i className="fas fa-server"></i>
//               {/* Wiring • Boards • Checkup  */}
//               {t("electrician.form.wiring_checkup_title") ||
//                 " Wiring • Boards • Checkup"}
//             </h3>
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup">
//                 {/* <label>{t("electrician.form.labels.doorbell_setup")}</label> */}
//                 <label htmlFor="doorbellsetup" className="tooltip-label">
//                   {/* New Wiring Point */}
//                   {t("electrician.form.labels.new_wiring_point") ||
//                     "New Wiring Point"}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.new_wiring_point.title") ||
//                       "New Wiring Point"
//                     }
//                     description={t("electrician.tooltips.new_wiring_point.description", {
//                       price: unit("new_wiring_point"),
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="nwp"
//                   value={newWiringPoint}
//                   setValue={setNewWiringPoint}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 {/* <label>{t("electrician.form.labels.exhaust_fan_setup")}</label> */}
//                 <label htmlFor="exhaustfansetup" className="tooltip-label">
//                   {/* Main Circuit Board Setup */}
//                   {t("electrician.form.labels.main_circuit_board_setup") ||
//                     "Main Circuit Board Setup"}
//                   <ServiceTooltip
//                     title={
//                       t(
//                         "electrician.tooltips.main_circuit_board_setup.title"
//                       ) || "Main Circuit Board Setup"
//                     }
//                     description={t("electrician.tooltips.main_circuit_board_setup.description", {
//                       price: unit("main_circuit_board_setup"),
//                     })}

//                   />
//                 </label>
//                 <PlusMinusInput
//                   id="mcbs"
//                   value={mainCircuitBoardSetup}
//                   setValue={setMainCircuitBoardSetup}
//                 />
//               </div>

//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="needsCheckup" className="tooltip-label">
//                   {t("electrician.form.labels.needs_checkup")}
//                   <ServiceTooltip
//                     title={
//                       t("electrician.tooltips.needs_checkup.title") ||
//                       "Electrical Checkup / Diagnosis"
//                     }
//                     description={t("electrician.tooltips.needs_checkup.description", {
//                       price: CHECKUP_FEE,
//                     })}

//                   />
//                 </label>
//                 <select
//                   id="electricalCheckup"
//                   value={electricalCheckup ? "yes" : "no"}
//                   onChange={(e) =>
//                     setElectricalCheckup(e.target.value === "yes")
//                   }
//                 >
//                   <option value="no">
//                     {t("electrician.form.labels.needs_checkup_options.no")}
//                   </option>
//                   <option value="yes">
//                     {t("electrician.form.labels.needs_checkup_options.yes")}
//                   </option>
//                 </select>
//               </div>

//               {/* <div className="ElectricianService-optionGroup">
                
//                 <label htmlFor="exhaustfanrepair" className="tooltip-label">
//     {t("electrician.form.labels.exhaust_fan_repair")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.exhaust_fan_repair.title") || "Exhaust Fan Repair"}
//       description={t("electrician.tooltips.exhaust_fan_repair.description") || "Fan blades stuck or motor humming loudly? Repair cleans, lubricates, and fixes wiring in exhaust fans to restore airflow, reducing humidity and mold risks in your space."}
//     />
//   </label>
//                 <PlusMinusInput
//                   value={exhaustFanRepair}
//                   setValue={setExhaustFanRepair}
//                 />
//               </div>
//               <div className="ElectricianService-optionGroup">

//                 <label htmlFor="drillwallholes" className="tooltip-label">
//     {t("electrician.form.labels.drill_wall_holes")}
//     <ServiceTooltip
//       title={t("electrician.tooltips.drill_wall_holes.title") || "Drill Wall Holes"}
//       description={t("electrician.tooltips.drill_wall_holes.description") || "Mounting shelves, TVs, or AC units requires clean wall holes? We drill precisely with dust control and safety checks to avoid pipes or wires, making your installations sturdy and neat."}
//     />
//   </label>
//                 <PlusMinusInput
//                   value={drillWallHoles}
//                   setValue={setDrillWallHoles}
//                 />
//               </div> */}
//             </div>

//             {rebookState && prevServitorName && (
//               <div className="rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   {/* {t('electrician.form.rebook_same_servitor')} */}
//                   {/* {` Do you want to book ${prevServitorName} again?`} */}
//                   <span className="rebook-text">
//                     {t("electrician.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("electrician.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             {/* ---------- Price Breakdown Card (like AC) ---------- */}
//             {breakdownRows.length > 0 && (
//               <div
//                 className="ElectricianService-breakdownCard"
//                 aria-live="polite"
//               >
//                 <div className="ElectricianService-breakdownHeader">
//                   <svg
//                     width="18"
//                     height="18"
//                     viewBox="0 0 24 24"
//                     fill="currentColor"
//                     aria-hidden="true"
//                   >
//                     <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
//                   </svg>
//                   <span>
//                     {t("electrician.breakdown.title", "Price Breakdown")}
//                   </span>
//                 </div>
//                 <ul className="ElectricianService-breakdownList">
//                   {breakdownRows.map((row, idx) => (
//                     <li key={idx} className="ElectricianService-breakdownRow">
//                       <span className="ElectricianService-breakdownLabel">
//                         {row.label}
//                       </span>
//                       <span className="ElectricianService-breakdownRight">
//                         {row.calc && (
//                           <span className="ElectricianService-breakdownCalc">
//                             {row.calc}
//                           </span>
//                         )}
//                         <span className="ElectricianService-breakdownTotal">
//                           {row.total}
//                         </span>
//                       </span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             {/* Price Display */}
//             <div className="ElectricianService-priceDisplay">
//               {/* <span>Estimated Price: {calculatePrice()} tk</span> */}
//               <span>
//                 {t("electrician.form.price_display", {
//                   price: calculatePrice(),
//                 })}
//               </span>
//               {/* <small>(Final price may vary based on complexity)</small> */}
//             </div>

//             {/* Pricing note banner */}
//             <div
//               className="ElectricianService-priceNote"
//               role="note"
//               aria-live="polite"
//             >
//               <div
//                 className="ElectricianService-priceNote-icon"
//                 aria-hidden="true"
//               >
//                 {/* small star icon (inline SVG so no extra imports) */}
//                 <svg
//                   viewBox="0 0 24 24"
//                   width="16"
//                   height="16"
//                   fill="currentColor"
//                 >
//                   <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
//                 </svg>
//               </div>
//               <div className="ElectricianService-priceNote-content">
//                 <div className="ElectricianService-priceNote-title">
//                   {t("electrician.price_note.title")}
//                 </div>
//                 <p className="ElectricianService-priceNote-text">
//                   <strong>
//                     {t("electrician.price_note.service_charges_only_label")}
//                   </strong>{" "}
//                   {t("electrician.price_note.body")}
//                 </p>
//               </div>
//             </div>

//             {/* Booking Details */}
//             <div className="ElectricianService-bookingDetails">
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="date">
//                   {/* Preferred Date */}
//                   {t("electrician.form.labels.date")}
//                 </label>
//                 {/* <input type="date" id="date" name="date" min={todayDate} onChange={(e) => setSelectedDate(e.target.value)} required /> */}
//                 <div className="ElectricianService-dateInputWrapper">
//                   {/* DatePicker Input */}
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()} // blocks past dates
//                     // placeholderText="Select a date"
//                     placeholderText={t("electrician.form.labels.date")}
//                     className="ElectricianService-dateInput"
//                   />
//                   {/* Calendar Icon */}
//                   <FaCalendarAlt
//                     className="ElectricianService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(
//                           ".react-datepicker__input-container input"
//                         )
//                         .click()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="ElectricianService-optionGroup">
//                 <label htmlFor="time">
//                   {/* Preferred Time */}
//                   {t("electrician.form.labels.time")}
//                 </label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* <h3 className="ElectricianService-sectionTitle">
//             <i className="fas fa-comment-alt"></i>
//             {t("electrician.form.remarks_title")}{" "}
//           </h3> */}
//             <div className="ElectricianService-serviceOptions">
//               <div className="ElectricianService-optionGroup ElectricianService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("electrician.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("electrician.form.placeholders.remarks")}
//                   className="ElectricianService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             <button type="submit"
//               className="ElectricianService-actionBtn"
//               disabled={!hasAnySelection}
//               aria-disabled={!hasAnySelection}

//             >
//               {/* Book Service Now */}
//               {/* {rebookState ? "Confirm Rebooking" : "Book Service Now"} */}
//               {rebookState
//                 ? t("electrician.form.rebook_button")
//                 : t("electrician.form.book_button")}
//             </button>
//           </form>

//           <div className="ElectricianService-infoBox">
//             <h4>{t("electrician.info_box.title")}</h4>{" "}
//             {/* CHANGED: Added translation */}
//             <p>{t("electrician.info_box.description")}</p>{" "}
//             {/* CHANGED: Added translation */}
//           </div>

//           <div className="ElectricianService-additionalInfo">
//             <div className="ElectricianService-sectionCard">
//               <h2 className="ElectricianService-sectionTitle">
//                 {t("electrician.additional_info.how_to_place_order.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <ol className="ElectricianService-stepList">
//                 {t("electrician.additional_info.how_to_place_order.steps", {
//                   returnObjects: true,
//                 }).map(
//                   (step, idx /* CHANGED: Added translation for array */) => (
//                     <li key={idx}>{step}</li>
//                   )
//                 )}
//               </ol>
//             </div>

//             <div className="ElectricianService-row2col">
//               <div className="ElectricianService-sectionCard ElectricianService-gradientBg2">
//                 <h2 className="ElectricianService-sectionTitle">
//                   {t("electrician.additional_info.why_choose_HelpNao.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <p className="ElectricianService-sectionText">
//                   {t(
//                     "electrician.additional_info.why_choose_HelpNao.description"
//                   )}{" "}
//                   {/* CHANGED: Added translation */}
//                 </p>
//                 <div className="ElectricianService-featureGrid">
//                   {t("electrician.additional_info.why_choose_HelpNao.features", {
//                     returnObjects: true,
//                   }).map(
//                     (
//                       feature,
//                       idx /* CHANGED: Added translation for array */
//                     ) => (
//                       <div key={idx} className="ElectricianService-featureItem">
//                         <i
//                           className={`fas fa-${idx === 0
//                               ? "balance-scale"
//                               : idx === 1
//                                 ? "user-shield"
//                                 : idx === 2
//                                   ? "mobile-alt"
//                                   : "headset"
//                             } ElectricianService-featureIcon`}
//                           aria-hidden="true"
//                         ></i>
//                         <p>{feature}</p>
//                       </div>
//                     )
//                   )}
//                 </div>
//               </div>

//               <div className="ElectricianService-sectionCard ElectricianService-gradientBg">
//                 <h2 className="ElectricianService-sectionTitle">
//                   {t("electrician.additional_info.key_features.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <div className="ElectricianService-featureGrid">
//                   {t("electrician.additional_info.key_features.features", {
//                     returnObjects: true,
//                   }).map(
//                     (
//                       feature,
//                       idx /* CHANGED: Added translation for array */
//                     ) => (
//                       <div key={idx} className="ElectricianService-featureItem">
//                         <i
//                           className={`fas fa-${idx === 0
//                               ? "clock"
//                               : idx === 1
//                                 ? "shield-alt"
//                                 : idx === 2
//                                   ? "check-circle"
//                                   : idx === 3
//                                     ? "credit-card"
//                                     : "credit-card"
//                             } ElectricianService-featureIcon`}
//                           aria-hidden="true"
//                         ></i>
//                         <p>{feature}</p>
//                       </div>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* <div className="ElectricianService-sectionCard">
//               <h2 className="ElectricianService-sectionTitle">
//                 {t("electrician.additional_info.mdb_mcb_service.title")}{" "}
//               </h2>
//               <div className="ElectricianService-mdbmcbGrid">
//                 <div className="ElectricianService-mdbmcbItem">
//                   <i
//                     className="fas fa-bolt ElectricianService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mdb.title"
//                       )}
//                     </h3>{" "}
//                     <p>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mdb.description"
//                       )}
//                     </p>{" "}
//                   </div>
//                 </div>
//                 <div className="ElectricianService-mdbmcbItem">
//                   <i
//                     className="fas fa-bolt ElectricianService-mdbmcbIcon"
//                     aria-hidden="true"
//                   ></i>
//                   <div>
//                     <h3>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mcb.title"
//                       )}
//                     </h3>{" "}
//                     <p>
//                       {t(
//                         "electrician.additional_info.mdb_mcb_service.mcb.description"
//                       )}
//                     </p>{" "}
//                   </div>
//                 </div>
//               </div>
//             </div> */}

//             <div className="ElectricianService-sectionCard ElectricianService-gradientBg3">
//               <h2 className="ElectricianService-sectionTitle">
//                 {t("electrician.additional_info.order_tracking.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <div className="ElectricianService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="ElectricianService-sectionText ElectricianService-centerText">
//                 {t("electrician.additional_info.order_tracking.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Order Form Modal */}
//         {showOrderForm && (
//           <ElectricianOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}

//         {/* Prompt Login Modal */}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>

//       {/* Add Feedback Section */}
//       <div className="electrician-feedback-section">
//         <FeedbackPage serviceType="Electrician" />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Electrician;




// ***** Upper code is okay, Update with 5% platform charge added min 50 (11-January-2026) ***** //

// ***** Update with new features and prices (22-Oct-2025) ***** //
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import { useTranslation } from "react-i18next";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaCalendarAlt,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";

import ElectricianOrderForm from "./ElectricianOrderForm";
import PromptLoginCard from "../PromptLoginCard";
import FeedbackPage from "../../Feedback/FeedbackPage";
import Footer from "../../../Components/Footer/Footer";

import heroImage from "../images/Electric-service-banner.png";
import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
import "./electricianStyle.css";
import Loader from "../../../Components/LoaderSpin/Loader";
import { ELECTRICIAN_PRICING } from "../servicePricing";
import SEO from "../../../Components/SEO/SEO";

const P = ELECTRICIAN_PRICING;
// const BASE_FEE = Number(P?.base ?? 0);
const PLATFORM_PERCENT = Number(P?.platformFee?.percent ?? 0.05);
const PLATFORM_MIN = Number(P?.platformFee?.min ?? 50);
const CHECKUP_FEE = Number(P?.checkupFlat ?? 0);

const Electrician = () => {
  const { t } = useTranslation();

  const [ratingData, setRatingData] = useState({
    reviewCount: 0,
    avgRating: 0,
  });

  const location = useLocation();
  const rebookState = location.state?.fromRebook || false;
  // const prevOrder   = location.state?.previousOrder || {};

  const prevOrder = useMemo(
    () => location.state?.previousOrder || {},
    [location.state?.previousOrder]
  );

  const [useSameServitor, setUseSameServitor] = useState(false); //new added for same servitor rebook
  const [prevServitorName, setPrevServitorName] = useState(""); //new added for same servitor rebook

  const [newCeilingFanInstallation, setNewCeilingFanInstallation] = useState(0);
  const [ceilingFanInstallation, setCeilingFanInstallation] = useState(0);
  const [ceilingFanUninstallation, setCeilingFanUninstallation] = useState(0);
  const [fanCoilNewWinding, setFanCoilNewWinding] = useState(0);
  const [fanCoilRepair, setFanCoilRepair] = useState(0);
  const [capacitorSetup, setCapacitorSetup] = useState(0);

  const [lightInstallation, setLightInstallation] = useState(0);
  const [lightRepair, setLightRepair] = useState(0);

  const [exhaustFanInstallation, setExhaustFanInstallation] = useState(0);
  const [exhaustFanCleaning, setExhaustFanCleaning] = useState(0);

  const [switchSetup, setSwitchSetup] = useState(0);
  const [socketSetup, setSocketSetup] = useState(0);
  const [regulatorSetup, setRegulatorSetup] = useState(0);

  const [newWiringPoint, setNewWiringPoint] = useState(0);
  const [mainCircuitBoardSetup, setMainCircuitBoardSetup] = useState(0);

  const [doorbellInstallation, setDoorbellInstallation] = useState(0);
  const [drillHoleService, setDrillHoleService] = useState(0);

  const [ipsInstallationExistingLine, setIpsInstallationExistingLine] = useState(0);
  const [ipsNewLineInstallation, setIpsNewLineInstallation] = useState(0);

  const [electricalCheckup, setElectricalCheckup] = useState(false);

  const [remarks, setRemarks] = useState("");
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  // const [selectedDate, setSelectedDate] = useState(new Date());


  const toLocalYMD = (d) => {
    const x = new Date(d);
    const y = x.getFullYear();
    const m = String(x.getMonth() + 1).padStart(2, "0");
    const day = String(x.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };


  // const getInitialDate = () => {
  //   const now = new Date();
  //   const currentHour = now.getHours();
  //   // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
  //   if (currentHour < 7 || currentHour >= 21) {
  //     const tomorrow = new Date();
  //     tomorrow.setDate(now.getDate() + 1);
  //     return tomorrow;
  //   }
  //   return now;
  // };

  const getInitialDate = () => {
    const now = new Date();
    const currentHour = now.getHours();

    // before 7am or after/equal 9pm -> tomorrow
    if (currentHour < 7 || currentHour >= 21) {
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      return tomorrow;
    }
    return now;
  };


  const [selectedDate, setSelectedDate] = useState(getInitialDate());

  // const [selectedTime, setSelectedTime]   = useState('');

  useEffect(() => {
    if (rebookState) {
      setNewCeilingFanInstallation(prevOrder.new_ceiling_fan_installation || 0);
      setCeilingFanInstallation(prevOrder.ceiling_fan_installation || 0);
      setCeilingFanUninstallation(prevOrder.ceiling_fan_uninstallation || 0);
      setFanCoilNewWinding(prevOrder.fan_coil_new_winding || 0);
      setFanCoilRepair(prevOrder.fan_coil_repair || 0);
      setCapacitorSetup(prevOrder.capacitor_setup || 0);

      setLightInstallation(prevOrder.light_installation || 0);
      setLightRepair(prevOrder.light_repair || 0);

      setExhaustFanInstallation(prevOrder.exhaust_fan_installation || 0);
      setExhaustFanCleaning(prevOrder.exhaust_fan_cleaning || 0);

      setSwitchSetup(prevOrder.switch_setup || 0);
      setSocketSetup(prevOrder.socket_setup || 0);
      setRegulatorSetup(prevOrder.regulator_setup || 0);

      setNewWiringPoint(prevOrder.new_wiring_point || 0);
      setMainCircuitBoardSetup(prevOrder.main_circuit_board_setup || 0);

      setDoorbellInstallation(prevOrder.doorbell_installation || 0);
      setDrillHoleService(prevOrder.drill_hole_service || 0);

      setIpsInstallationExistingLine(
        prevOrder.ips_installation_existing_line || 0
      );
      setIpsNewLineInstallation(prevOrder.ips_new_line_installation || 0);

      setElectricalCheckup(!!prevOrder.Electrical_checkup);
    }
  }, [rebookState, prevOrder]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.Id;
          const extractedUserId = userId.startsWith("user-")
            ? userId.split("user-")[1]
            : userId;

          const response = await axios.get(`${URL}/user/${extractedUserId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
    window.scrollTo(0, 0);
  }, []);

  //new added for same servitor rebook
  useEffect(() => {
    if (rebookState && prevOrder.servitor_id) {
      axios
        .get(`${URL}/servitors/${prevOrder.servitor_id}`)
        .then((res) => {
          const s = res.data;
          setPrevServitorName(`${s.FirstName} ${s.LastName}`);
        })
        .catch((err) => console.error("Error fetching servitor:", err));
    }
  }, [rebookState, prevOrder.servitor_id]);


  useEffect(() => {
    const loadRatings = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${URL}/api/ratings`);
        const { electrician = {} } = data;
        setRatingData({
          reviewCount: electrician.reviewCount || 0,
          avgRating: electrician.avgRating || 0,
        });
      } catch (err) {
        console.error("Failed to load ratings:", err);
      } finally {
        setLoading(false);
      }
    };
    loadRatings();
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }
    return stars;
  };

  const generateTimeSlots = (dateObj) => {
    const startTime = 7;
    const endTime = 21;
    const slots = [];
    const now = new Date();
    // const todayStr = now.toISOString().split("T")[0];
    // const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

    const todayStr = toLocalYMD(now);
    const selectedDateStr = dateObj ? toLocalYMD(dateObj) : "";


    let startHour = startTime;
    let startMinute = 0;

    // If the selected date is today, adjust slots based on current time
    if (selectedDateStr === todayStr) {
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      if (currentHour >= endTime) {
        return []; // No slots available for today
      }
      if (currentHour >= startTime) {
        // Round up to the next half-hour
        if (currentMinute > 0 && currentMinute <= 30) {
          startHour = currentHour;
          startMinute = 30;
        } else if (currentMinute > 30) {
          startHour = currentHour + 1;
          startMinute = 0;
        } else {
          startHour = currentHour;
          startMinute = 0;
        }
      }
    }

    for (let hour = startHour; hour <= endTime; hour++) {
      const minuteStart = hour === startHour ? startMinute : 0;
      for (let minute = minuteStart; minute < 60; minute += 30) {
        // Skip past slots for today
        if (selectedDateStr === todayStr) {
          const slotTime = new Date(now);
          slotTime.setHours(hour, minute, 0, 0);
          if (slotTime <= now) continue;
        }
        const displayHour = hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedTime = `${displayHour}:${String(minute).padStart(
          2,
          "0"
        )} ${ampm}`;
        slots.push(formattedTime);
      }
    }
    return slots;
  };

  // Price Calculate & breakdown
  // ---------- Pricing helpers ----------

  const U = useCallback((v) => Math.max(0, Number(v) || 0), []);

  const roundTk = useCallback((n) => Math.round(Number(n) || 0), []);

  const fmtTk = useCallback(
    (n) => `${(Number(n) || 0).toLocaleString()} tk`,
    []
  );

  // ***** Update for drill holes ***** //
  const getRate = useCallback((key) => P?.perUnit?.[key] ?? 0, []);

  const unit = useCallback(
    (key) => {
      const r = getRate(key);
      return typeof r === "number" ? Number(r) : 0;
    },
    [getRate]
  );

  // supports both number and { first, additional }
  const lineTotal = useCallback(
    (key, count) => {
      const c = U(count);
      if (!c) return 0;

      const r = getRate(key);

      if (typeof r === "number") return c * r;

      const first = Number(r.first ?? 0);
      const add = Number(r.additional ?? r.first ?? 0);
      return first + Math.max(0, c - 1) * add;
    },
    [U, getRate]
  );

  const drillRate = useMemo(() => getRate("drill_hole_service"), [getRate]);

  const DRILL_FIRST = useMemo(
    () =>
      typeof drillRate === "object"
        ? Number(drillRate?.first ?? 0)
        : Number(drillRate ?? 0),
    [drillRate]
  );

  const DRILL_PER_HOLE = useMemo(
    () =>
      typeof drillRate === "object"
        ? Number(drillRate?.additional ?? 0)
        : 0,
    [drillRate]
  );

  // ── TRUE when ANY service selected (counts > 0) or checkup chosen
  const hasAnySelection = useMemo(() => {
    const counts = [
      newCeilingFanInstallation,
      ceilingFanInstallation,
      ceilingFanUninstallation,
      fanCoilNewWinding,
      fanCoilRepair,
      capacitorSetup,
      lightInstallation,
      lightRepair,
      exhaustFanInstallation,
      exhaustFanCleaning,
      switchSetup,
      socketSetup,
      regulatorSetup,
      newWiringPoint,
      mainCircuitBoardSetup,
      doorbellInstallation,
      drillHoleService,
      ipsInstallationExistingLine,
      ipsNewLineInstallation,
    ];
    return counts.some((c) => U(c) > 0) || !!electricalCheckup;
  }, [
    U,
    newCeilingFanInstallation,
    ceilingFanInstallation,
    ceilingFanUninstallation,
    fanCoilNewWinding,
    fanCoilRepair,
    capacitorSetup,
    lightInstallation,
    lightRepair,
    exhaustFanInstallation,
    exhaustFanCleaning,
    switchSetup,
    socketSetup,
    regulatorSetup,
    newWiringPoint,
    mainCircuitBoardSetup,
    doorbellInstallation,
    drillHoleService,
    ipsInstallationExistingLine,
    ipsNewLineInstallation,
    electricalCheckup,
  ]);

  // ---------- Subtotal ----------
  const subtotal = useMemo(() => {
    if (!hasAnySelection) return 0;

    let s = 0;

    s += U(newCeilingFanInstallation) * unit("new_ceiling_fan_installation");
    s += U(ceilingFanInstallation) * unit("ceiling_fan_installation");
    s += U(ceilingFanUninstallation) * unit("ceiling_fan_uninstallation");
    s += U(fanCoilNewWinding) * unit("fan_coil_new_winding");
    s += U(fanCoilRepair) * unit("fan_coil_repair");
    s += U(capacitorSetup) * unit("capacitor_setup");

    s += U(lightInstallation) * unit("light_installation");
    s += U(lightRepair) * unit("light_repair");

    s += U(exhaustFanInstallation) * unit("exhaust_fan_installation");
    s += U(exhaustFanCleaning) * unit("exhaust_fan_cleaning");

    s += U(switchSetup) * unit("switch_setup");
    s += U(socketSetup) * unit("socket_setup");
    s += U(regulatorSetup) * unit("regulator_setup");

    s += U(newWiringPoint) * unit("new_wiring_point");
    s += U(mainCircuitBoardSetup) * unit("main_circuit_board_setup");

    s += U(doorbellInstallation) * unit("doorbell_installation");
    s += lineTotal("drill_hole_service", drillHoleService);

    s += U(ipsInstallationExistingLine) * unit("ips_installation_existing_line");
    s += U(ipsNewLineInstallation) * unit("ips_new_line_installation");

    if (electricalCheckup) s += CHECKUP_FEE;

    return roundTk(s);
  }, [
    hasAnySelection,
    U,
    unit,
    lineTotal,
    roundTk,
    newCeilingFanInstallation,
    ceilingFanInstallation,
    ceilingFanUninstallation,
    fanCoilNewWinding,
    fanCoilRepair,
    capacitorSetup,
    lightInstallation,
    lightRepair,
    exhaustFanInstallation,
    exhaustFanCleaning,
    switchSetup,
    socketSetup,
    regulatorSetup,
    newWiringPoint,
    mainCircuitBoardSetup,
    doorbellInstallation,
    drillHoleService,
    ipsInstallationExistingLine,
    ipsNewLineInstallation,
    electricalCheckup,
  ]);

  // ---------- Platform Fee (5% with min 50) ----------
  const platformFee = useMemo(() => {
    if (!hasAnySelection) return 0;
    const percentFee = roundTk(subtotal * PLATFORM_PERCENT);
    return Math.max(PLATFORM_MIN, percentFee);
  }, [hasAnySelection, roundTk, subtotal]);

  // ---------- Total ----------
  const totalPrice = useMemo(() => {
    if (!hasAnySelection) return 0;
    return roundTk(subtotal + platformFee);
  }, [hasAnySelection, roundTk, subtotal, platformFee]);

  // keep your old function name so you don't need to change JSX lines
  const calculatePrice = useCallback(() => totalPrice, [totalPrice]);

  // ---------- Breakdown rows ----------
  const breakdownRows = useMemo(() => {
    const rows = [];

    const add = (label, count, key) => {
      const c = U(count);
      if (!c) return;

      const r = getRate(key);

      // normal numeric pricing
      if (typeof r === "number") {
        rows.push({
          label,
          calc: `${c} × ${fmtTk(r)} =`,
          total: fmtTk(c * r),
        });
        return;
      }

      // {first, additional} pricing (drill holes)
      const first = Number(r.first ?? 0);
      const additional = Number(r.additional ?? 0);

      if (c === 1) {
        rows.push({
          label,
          calc: `${fmtTk(first)} =`,
          total: fmtTk(first),
        });
      } else {
        rows.push({
          label,
          calc: `${fmtTk(first)} + ${c - 1} × ${fmtTk(additional)} =`,
          total: fmtTk(first + (c - 1) * additional),
        });
      }
    };

    // Fan & Coil
    add(
      t("electrician.breakdown.new_ceiling_fan_installation", "New Ceiling Fan Installation"),
      newCeilingFanInstallation,
      "new_ceiling_fan_installation"
    );
    add(
      t("electrician.breakdown.ceiling_fan_install", "Ceiling Fan Installation"),
      ceilingFanInstallation,
      "ceiling_fan_installation"
    );
    add(
      t("electrician.breakdown.ceiling_fan_uninstall", "Ceiling Fan Uninstallation"),
      ceilingFanUninstallation,
      "ceiling_fan_uninstallation"
    );
    add(
      t("electrician.breakdown.fan_coil_new_winding", "Fan Coil New Winding"),
      fanCoilNewWinding,
      "fan_coil_new_winding"
    );
    add(
      t("electrician.breakdown.fan_coil_repair", "Fan Coil Repair"),
      fanCoilRepair,
      "fan_coil_repair"
    );
    add(
      t("electrician.breakdown.capacitor_setup", "Capacitor Setup"),
      capacitorSetup,
      "capacitor_setup"
    );

    // Light & Exhaust
    add(
      t("electrician.breakdown.light_install", "Light Installation"),
      lightInstallation,
      "light_installation"
    );
    add(
      t("electrician.breakdown.light_repair", "Light Repair"),
      lightRepair,
      "light_repair"
    );
    add(
      t("electrician.breakdown.exhaust_fan_install", "Exhaust Fan Installation"),
      exhaustFanInstallation,
      "exhaust_fan_installation"
    );
    add(
      t("electrician.breakdown.exhaust_fan_clean", "Exhaust Fan Cleaning"),
      exhaustFanCleaning,
      "exhaust_fan_cleaning"
    );

    // Switch • Socket • Regulator
    add(
      t("electrician.breakdown.switch_setup", "Switch Setup"),
      switchSetup,
      "switch_setup"
    );
    add(
      t("electrician.breakdown.socket_setup", "Socket Setup"),
      socketSetup,
      "socket_setup"
    );
    add(
      t("electrician.breakdown.regulator_setup", "Regulator Setup"),
      regulatorSetup,
      "regulator_setup"
    );

    // Wiring & Boards
    add(
      t("electrician.breakdown.new_wiring_point", "New Wiring Point"),
      newWiringPoint,
      "new_wiring_point"
    );
    add(
      t("electrician.breakdown.main_circuit_board_setup", "Main Circuit Board Setup"),
      mainCircuitBoardSetup,
      "main_circuit_board_setup"
    );

    // Doorbell • Drilling • IPS
    add(
      t("electrician.breakdown.doorbell_install", "Doorbell Installation"),
      doorbellInstallation,
      "doorbell_installation"
    );
    add(
      t("electrician.breakdown.drill_hole_service", "Drill Hole Service"),
      drillHoleService,
      "drill_hole_service"
    );
    add(
      t("electrician.breakdown.ips_existing", "IPS Installation (Existing Line)"),
      ipsInstallationExistingLine,
      "ips_installation_existing_line"
    );
    add(
      t("electrician.breakdown.ips_new_line", "IPS New Line Installation"),
      ipsNewLineInstallation,
      "ips_new_line_installation"
    );

    // Flat checkup
    if (electricalCheckup) {
      rows.push({
        label: t("electrician.breakdown.electrical_checkup", "Electrical Checkup"),
        calc: "",
        total: fmtTk(CHECKUP_FEE),
      });
    }

    // Platform fee line (5% with min)

    // if (hasAnySelection) {
    //   const percentFee = roundTk(subtotal * PLATFORM_PERCENT);
    //   const isMinApplied = percentFee < PLATFORM_MIN;
    //   rows.push({
    //     label: t("electrician.breakdown.platform_fee", "Platform & Support Fee"),
    //     calc: isMinApplied
    //       ? `${roundTk(PLATFORM_PERCENT * 100)}% of ${fmtTk(subtotal)} = ${fmtTk(percentFee)} (min ${fmtTk(PLATFORM_MIN)})`
    //       : `${roundTk(PLATFORM_PERCENT * 100)}% of ${fmtTk(subtotal)} =`,
    //     total: fmtTk(platformFee),
    //   });
    // }

    if (hasAnySelection) {
      rows.push({
        label: t("electrician.breakdown.platform_fee", "Platform & Support Fee"),
        // calc: "",
        total: fmtTk(platformFee),
      });
    }

    return rows;
  }, [
    t,
    U,
    fmtTk,
    getRate,
    // roundTk,
    // subtotal,
    platformFee,
    hasAnySelection,
    newCeilingFanInstallation,
    ceilingFanInstallation,
    ceilingFanUninstallation,
    fanCoilNewWinding,
    fanCoilRepair,
    capacitorSetup,
    lightInstallation,
    lightRepair,
    exhaustFanInstallation,
    exhaustFanCleaning,
    switchSetup,
    socketSetup,
    regulatorSetup,
    newWiringPoint,
    mainCircuitBoardSetup,
    doorbellInstallation,
    drillHoleService,
    ipsInstallationExistingLine,
    ipsNewLineInstallation,
    electricalCheckup,
  ]);
  // Handle form submission
  const handleGetService = (e) => {
    e.preventDefault();

    if (!hasAnySelection) return;

    // const date = e.target.date.value;
    const time = e.target.time.value;
    // setSelectedDate(date);
    let dateStr = "";
    if (selectedDate) {
      // dateStr = selectedDate.toISOString().split("T")[0];
      dateStr = toLocalYMD(selectedDate);
    }

    // const platform_fee = platformFee;

    const formDetails = {
      new_ceiling_fan_installation: newCeilingFanInstallation,
      ceiling_fan_installation: ceilingFanInstallation,
      ceiling_fan_uninstallation: ceilingFanUninstallation,
      fan_coil_new_winding: fanCoilNewWinding,
      fan_coil_repair: fanCoilRepair,
      capacitor_setup: capacitorSetup,

      light_installation: lightInstallation,
      light_repair: lightRepair,

      exhaust_fan_installation: exhaustFanInstallation,
      exhaust_fan_cleaning: exhaustFanCleaning,

      switch_setup: switchSetup,
      socket_setup: socketSetup,
      regulator_setup: regulatorSetup,

      new_wiring_point: newWiringPoint,
      main_circuit_board_setup: mainCircuitBoardSetup,

      doorbell_installation: doorbellInstallation,
      drill_hole_service: drillHoleService,

      ips_installation_existing_line: ipsInstallationExistingLine,
      ips_new_line_installation: ipsNewLineInstallation,

      Electrical_checkup: electricalCheckup,

      remarks,

      subtotal,
      platform_fee: platformFee,
      platform_fee_percent: PLATFORM_PERCENT,
      platform_fee_min: PLATFORM_MIN,
      price: totalPrice,

      // price: calculatePrice(),
      // date,
      date: dateStr,
      time,

      // new added for rebook same servitor
      useSameServitor,
      servitor_id: useSameServitor
        ? prevOrder.servitor_id // carry through the original servitor’s ID
        : undefined,
    };
    setFormData(formDetails);

    // If user is logged in, show the order form; otherwise prompt for login
    if (user) {
      setShowOrderForm(true);
    } else {
      setShowLoginPrompt(true);
    }
  };

  // Once user confirms the order in ElectricianOrderForm
  const handleOrderSubmit = (orderData) => {
    // console.log("Order Data:", orderData);
    setShowOrderForm(false);

    // 2) Reset _every_ form‐state back to its initial “empty” value:
    setNewCeilingFanInstallation(0);
    setCeilingFanInstallation(0);
    setCeilingFanUninstallation(0);
    setFanCoilNewWinding(0);
    setFanCoilRepair(0);
    setCapacitorSetup(0);

    setLightInstallation(0);
    setLightRepair(0);

    setExhaustFanInstallation(0);
    setExhaustFanCleaning(0);

    setSwitchSetup(0);
    setSocketSetup(0);
    setRegulatorSetup(0);

    setNewWiringPoint(0);
    setMainCircuitBoardSetup(0);

    setDoorbellInstallation(0);
    setDrillHoleService(0);

    setIpsInstallationExistingLine(0);
    setIpsNewLineInstallation(0);

    setElectricalCheckup(false);
    setRemarks("");
    setUseSameServitor(false);
    setFormData({});
  };

  // Get today's date in YYYY-MM-DD format for the min attribute
  // const todayDate = new Date().toISOString().split('T')[0];

  // const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
  //   const { t } = useTranslation();
  //   const handleIncrement = () => {
  //     if (value < max) {
  //       setValue(value + 1);
  //     }
  //   };

  //   const handleDecrement = () => {
  //     if (value > min) {
  //       setValue(value - 1);
  //     }
  //   };

  //   // const displayText = `${value} ${value === 1 ? 'unit' : 'units'}`;
  //   const displayText = `${value} ${t(
  //     value === 1 ? "electrician.form.unit" : "electrician.form.units"
  //   )}`;

  //   return (
  //     <div className="ElectricianService-plusMinusInput">
  //       <button
  //         type="button"
  //         className="ElectricianService-minusBtn"
  //         onClick={handleDecrement}
  //         disabled={value <= min}
  //       >
  //         −
  //       </button>
  //       <span className="ElectricianService-valueDisplay">{displayText}</span>
  //       <button
  //         type="button"
  //         className="ElectricianService-plusBtn"
  //         onClick={handleIncrement}
  //         disabled={value >= max}
  //       >
  //         +
  //       </button>
  //     </div>
  //   );
  // };

  const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
    const { t } = useTranslation();
    const inc = () => value < max && setValue(value + 1);
    const dec = () => value > min && setValue(value - 1);
    const display = `${value} ${t(
      value === 1 ? "electrician.form.unit" : "electrician.form.units"
    )}`;
    return (
      <div className="ElectricianService-plusMinusInput">
        <button
          type="button"
          className="ElectricianService-minusBtn"
          onClick={dec}
          disabled={value <= min}
        >
          −
        </button>
        <span className="ElectricianService-valueDisplay">{display}</span>
        <button
          type="button"
          className="ElectricianService-plusBtn"
          onClick={inc}
          disabled={value >= max}
        >
          +
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="ElectricianService-container">
        <SEO
          title="Electrician Service in Bangladesh | HelpNao"
          description="Book trusted electricians for wiring, fan/light repair, sockets, switch issues, and emergency fixes. Fast service, verified professionals."
          path="/services/electrician"
          lang="en"
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Electrician Service",
            "provider": { "@type": "Organization", "name": "HelpNao" },
            "areaServed": "Dhaka, Bangladesh",
            "serviceType": "Electrician"
          }}
        />

        <Navbar />
        <Loader show={loading} />
        {/* Service Card */}
        <div className="ElectricianService-card">
          {/* Hero Section */}
          <div className="ElectricianService-hero">
            <img src={heroImage} alt="Electrician Services Hero" />
          </div>

          <div className="ElectricianService-header">
            {/* <h1>Professional Electrician Services</h1> */}
            {/* <h1>
            {rebookState
              ? "Rebook Electrician Service"
              : "Professional Electrician Services"}
          </h1> */}
            <h1>
              {rebookState
                ? t("electrician.header.rebook_title")
                : t("electrician.header.title")}
            </h1>
            {/* <div className="ElectricianService-rating">★★★★★</div>
          <div className="ElectricianService-reviews">
            82,708 Verified Reviews
          </div> */}

            <div className="ElectricianService-rating">
              {renderStars(ratingData.avgRating)}
            </div>
            <div className="ElectricianService-reviews">
              {ratingData.reviewCount.toLocaleString()}{" "}
              {t("electrician.reviewsLabel")}
            </div>
          </div>

          {/* The Service Form */}
          <form onSubmit={handleGetService} className="ElectricianService-form">
            {/* Row 1: Fans & Regulators */}
            <h3 className="ElectricianService-sectionTitle">
              <i className="fas fa-fan"></i>{" "}
              {t("electrician.form.fan_services_title") || "Fan Services"}
            </h3>
            <div className="ElectricianService-serviceOptions">


              <div className="ElectricianService-optionGroup">
                <label htmlFor="newCeilingFanInstall" className="tooltip-label">
                  {t("electrician.form.labels.new_ceiling_fan_installation") ||
                    "New Ceiling Fan Installation"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.new_ceiling_fan_installation.title") ||
                      "New Ceiling Fan Installation (with fresh mount/wiring)"
                    }
                    description={
                      t("electrician.tooltips.new_ceiling_fan_installation.description", {
                        price: unit("new_ceiling_fan_installation"),
                      })}
                  />
                </label>
                <PlusMinusInput
                  id="ncfi"
                  value={newCeilingFanInstallation}
                  setValue={setNewCeilingFanInstallation}
                />
              </div>

              <div className="ElectricianService-optionGroup">
                <label htmlFor="fanInstall" className="tooltip-label">
                  {/* Ceiling Fan Installation */}
                  {t("electrician.form.labels.ceiling_fan_installation") ||
                    "Ceiling Fan Installation"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.fan_install.title") ||
                      "Ceiling/Wall Fan Installation"
                    }
                    description={t("electrician.tooltips.fan_install.description", {
                      price: unit("ceiling_fan_installation"),
                    })}
                  />
                </label>
                <PlusMinusInput
                  id="cfi"
                  value={ceilingFanInstallation}
                  setValue={setCeilingFanInstallation}
                />
              </div>
              <div className="ElectricianService-optionGroup">
                <label htmlFor="fanRepair" className="tooltip-label">
                  {/* Ceiling Fan Uninstallation */}
                  {t("electrician.form.labels.ceiling_fan_uninstallation") ||
                    "Ceiling Fan Uninstallation"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.fan_uninstall.title") ||
                      "Ceiling Fan Uninstallation"
                    }
                    description={t("electrician.tooltips.fan_uninstall.description", {
                      price: unit("ceiling_fan_uninstallation"),
                    })}

                  />
                </label>

                <PlusMinusInput
                  id="cfu"
                  value={ceilingFanUninstallation}
                  setValue={setCeilingFanUninstallation}
                />
              </div>
            </div>

            <div className="ElectricianService-serviceOptions">
              <div className="ElectricianService-optionGroup">
                <label htmlFor="fancoilSetup" className="tooltip-label">
                  {/* Fan Coil New Winding */}
                  {t("electrician.form.labels.fan_coil_new_winding") ||
                    "Fan Coil New Winding"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.fan_coil_new_winding.title") ||
                      "Fan Coil New Winding"
                    }
                    description={t("electrician.tooltips.fan_coil_new_winding.description", {
                      price: unit("fan_coil_new_winding"),
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="fcnw"
                  value={fanCoilNewWinding}
                  setValue={setFanCoilNewWinding}
                />
              </div>
              <div className="ElectricianService-optionGroup">

                <label htmlFor="fancoilRepair" className="tooltip-label">
                  {/* Fan Coil Repair */}
                  {t("electrician.form.labels.fan_coil_repair") ||
                    "Fan Coil Repair"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.coil_repair.title") ||
                      "Fan Coil Repair"
                    }
                    description={t("electrician.tooltips.coil_repair.description", {
                      price: unit("fan_coil_repair"),
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="fcr"
                  value={fanCoilRepair}
                  setValue={setFanCoilRepair}
                />
              </div>

              <div className="ElectricianService-optionGroup">
                <label htmlFor="capacitorsetup" className="tooltip-label">
                  {/* Capacitor Setup */}
                  {t("electrician.form.labels.capacitor_setup") ||
                    "Capacitor Setup"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.capacitor_setup.title") ||
                      "Fan Capacitor Setup/Replacement"
                    }
                    description={t("electrician.tooltips.capacitor_setup.description", {
                      price: unit("capacitor_setup"),
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="caps"
                  value={capacitorSetup}
                  setValue={setCapacitorSetup}
                />
              </div>
            </div>

            {/* Row 2: Lights & Sockets */}
            <h3 className="ElectricianService-sectionTitle">
              <i className="fas fa-lightbulb"></i>{" "}
              {t("electrician.form.lighting_sockets_title") ||
                "Light & Exhaust Fan"}
            </h3>
            <div className="ElectricianService-serviceOptions">
              <div className="ElectricianService-optionGroup">
                <label htmlFor="lightInstall" className="tooltip-label">
                  {t("electrician.form.labels.light_install") ||
                    "Light Install"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.light_install.title") ||
                      "Light Install/Uninstall"
                    }
                    description={t("electrician.tooltips.light_install.description", {
                      price: unit("light_installation"),
                    })}

                  />
                </label>

                <PlusMinusInput
                  id="li"
                  value={lightInstallation}
                  setValue={setLightInstallation}
                />
              </div>
              {/* <div className="ElectricianService-optionGroup">
                <label htmlFor="lightRepair" className="tooltip-label">
                  {t("electrician.form.labels.light_repair") || "Light Repair"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.light_repair.title") ||
                      "Light Repair"
                    }
                    description={t(
                      "electrician.tooltips.light_repair.description"
                    )}
                  />
                </label>

                <PlusMinusInput
                  id="lr"
                  value={lightRepair}
                  setValue={setLightRepair}
                />
              </div> */}

              <div className="ElectricianService-optionGroup">

                <label htmlFor="socketInstall" className="tooltip-label">
                  {/* Exhaust Fan Installation */}
                  {t("electrician.form.labels.exhaust_fan_installation") ||
                    "Exhaust Fan Installation"}
                  <ServiceTooltip
                    title={
                      t(
                        "electrician.tooltips.exhaust_fan_installation.title"
                      ) || "Exhaust Fan Installation"
                    }
                    description={t("electrician.tooltips.exhaust_fan_installation.description", {
                      price: unit("exhaust_fan_installation"),
                    })}

                  />
                </label>

                <PlusMinusInput
                  id="efi"
                  value={exhaustFanInstallation}
                  setValue={setExhaustFanInstallation}
                />
              </div>
              {/* <div className="ElectricianService-optionGroup">
                <label htmlFor="socketRepair" className="tooltip-label">
                  {t("electrician.form.labels.exhaust_fan_cleaning") ||
                    "Exhaust Fan Cleaning"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.exhaust_fan_cleaning.title") ||
                      "Exhaust Fan Cleaning"
                    }
                    description={t(
                      "electrician.tooltips.exhaust_fan_cleaning.description"
                    )}
                  />
                </label>

                <PlusMinusInput
                  id="efc"
                  value={exhaustFanCleaning}
                  setValue={setExhaustFanCleaning}
                />
              </div> */}
            </div>

            {/* Row 3: Panels & Breakers */}
            <h3 className="ElectricianService-sectionTitle">
              <i className="fas fa-toggle-on"></i>{" "}
              {t("electrician.form.panels_breakers_title") ||
                "Switch • Socket • Regulator"}
            </h3>
            <div className="ElectricianService-serviceOptions">
              <div className="ElectricianService-optionGroup">

                <label htmlFor="switchBoardRepair" className="tooltip-label">
                  {/* Switch Setup */}
                  {t("electrician.form.labels.switch_setup") || "Switch Setup"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.switch_setup.title") ||
                      "Switch Setup"
                    }
                    description={t("electrician.tooltips.switch_setup.description", {
                      price: unit("switch_setup"),
                    })}

                  />
                </label>

                <PlusMinusInput
                  id="sw"
                  value={switchSetup}
                  setValue={setSwitchSetup}
                />
              </div>
              <div className="ElectricianService-optionGroup">
                {/* <label htmlFor="mcbServicing">
                  {t("electrician.form.labels.mcb_servicing")}
                </label> */}
                <label htmlFor="mcbServicing" className="tooltip-label">
                  {/* Socket Setup */}
                  {t("electrician.form.labels.socket_setup") || "Socket Setup"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.socket_setup.title") ||
                      "Socket Setup"
                    }
                    description={t("electrician.tooltips.socket_setup.description", {
                      price: unit("socket_setup"),
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="so"
                  value={socketSetup}
                  setValue={setSocketSetup}
                />
              </div>
              <div className="ElectricianService-optionGroup">
                {/* <label htmlFor="mdbServicing">
                  {t("electrician.form.labels.mdb_servicing")}
                </label> */}

                <label htmlFor="mdbServicing" className="tooltip-label">
                  {/* Regulator Setup */}
                  {t("electrician.form.labels.regulator_setup") ||
                    "Regulator Setup"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.regulator_setup.title") ||
                      "Fan Regulator Setup"
                    }
                    description={t("electrician.tooltips.regulator_setup.description", {
                      price: unit("regulator_setup"),
                    })}

                  />
                </label>

                <PlusMinusInput
                  id="reg"
                  value={regulatorSetup}
                  setValue={setRegulatorSetup}
                />
              </div>
              {/* <div className="ElectricianService-optionGroup">
                <label htmlFor="breakerRepair" className="tooltip-label">
    {t("electrician.form.labels.breaker_repair")}
    <ServiceTooltip
      title={t("electrician.tooltips.breaker_repair.title") || "Circuit Breaker Repair"}
      description={t("electrician.tooltips.breaker_repair.description") || "Breakers not resetting or tripping randomly? We repair or replace them to handle high loads safely, preventing outages and protecting appliances from voltage spikes."}
    />
  </label>
                <PlusMinusInput
                  id="breakerRepair"
                  value={breakerRepair}
                  setValue={setBreakerRepair}
                />
              </div> */}
            </div>

            {/* Row 4: Wiring & Checkup */}
            <h3 className="ElectricianService-sectionTitle">
              <i className="fas fa-toolbox"></i>
              {/* Doorbell • Drilling • IPS */}
              {t("electrician.form.doorbell_exhaust_drilling_title") ||
                "Doorbell • Drilling • IPS"}
            </h3>

            <div className="ElectricianService-serviceOptions">
              <div className="ElectricianService-optionGroup">
                {/* <label htmlFor="newWiringPoint">
                  {t("electrician.form.labels.new_wiring_point")}
                </label> */}
                <label htmlFor="newWiringPoint" className="tooltip-label">
                  {/* Doorbell Installation */}
                  {t("electrician.form.labels.doorbell_installation") ||
                    "Doorbell Installation"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.doorbell_setup.title") ||
                      "Doorbell Setup (Wired/Wireless)"
                    }
                    description={t("electrician.tooltips.doorbell_setup.description", {
                      price: unit("doorbell_installation"),
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="db"
                  value={doorbellInstallation}
                  setValue={setDoorbellInstallation}
                />
              </div>

              {/* Coil Repair */}
              <div className="ElectricianService-optionGroup">
                {/* <label htmlFor="coilRepair">
                  {t("electrician.form.labels.coil_repair", "Fan Coil Repair")}
                </label> */}
                <label htmlFor="coilRepair" className="tooltip-label">
                  {/* Drill Hole Service */}
                  {t("electrician.form.labels.drill_hole_service") ||
                    " Drill Hole Service"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.drill_wall_holes.title") ||
                      "Drill Wall Holes"
                    }
                    description={t("electrician.tooltips.drill_wall_holes.description", {
                      first: DRILL_FIRST,
                      perHole: DRILL_PER_HOLE,
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="drill"
                  value={drillHoleService}
                  setValue={setDrillHoleService}
                />
              </div>

              {/* <div className="ElectricianService-optionGroup">
                <label htmlFor="ipsSetupLine" className="tooltip-label">
                  {t(
                    "electrician.form.labels.ips_installation_existing_line"
                  ) || "IPS Setup (Existing Line)"}
                  <ServiceTooltip
                    title={
                      t(
                        "electrician.tooltips.ips_install_existing_line.title"
                      ) || "IPS Installation (Existing Line)"
                    }
                    description={t(
                      "electrician.tooltips.ips_install_existing_line.description"
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="ips1"
                  value={ipsInstallationExistingLine}
                  setValue={setIpsInstallationExistingLine}
                />
              </div>
              <div className="ElectricianService-optionGroup">
                <label htmlFor="ipsSetupNewLine" className="tooltip-label">
                  {t("electrician.form.labels.ips_new_line_installation") ||
                    "IPS Setup (New Line)"}
                  <ServiceTooltip
                    title={
                      t(
                        "electrician.tooltips.ips_new_line_installation.title"
                      ) || "IPS New Line Installation"
                    }
                    description={t(
                      "electrician.tooltips.ips_new_line_installation.description"
                    )}
                  />
                </label>
                <PlusMinusInput
                  id="ips2"
                  value={ipsNewLineInstallation}
                  setValue={setIpsNewLineInstallation}
                />
              </div> */}



              {/* <div className="ElectricianService-optionGroup">

                <label htmlFor="needsCheckup" className="tooltip-label">
    {t("electrician.form.labels.needs_checkup")}
    <ServiceTooltip
      title={t("electrician.tooltips.needs_checkup.title") || "Electrical Checkup"}
      description={t("electrician.tooltips.needs_checkup.description") || "Worried about hidden wiring issues or outdated setups? A full checkup scans your home's electrics for faults, overloads, or safety risks, providing a report with fixes to keep your family protected."}
    />
  </label>
                <select
                  id="needsCheckup"
                  value={needsCheckup ? "yes" : "no"}
                  onChange={(e) => setNeedsCheckup(e.target.value === "yes")}
                >
                  <option value="no">
                    {t("electrician.form.labels.needs_checkup_options.no")}
                  </option>{" "}
                  <option value="yes">
                    {t("electrician.form.labels.needs_checkup_options.yes")}
                  </option>{" "}
                </select>
              </div> */}
            </div>

            <h3 className="ElectricianService-sectionTitle">
              <i className="fas fa-server"></i>
              {/* Wiring • Boards • Checkup  */}
              {t("electrician.form.wiring_checkup_title") ||
                " Wiring • Boards • Checkup"}
            </h3>
            <div className="ElectricianService-serviceOptions">
              <div className="ElectricianService-optionGroup">
                {/* <label>{t("electrician.form.labels.doorbell_setup")}</label> */}
                <label htmlFor="doorbellsetup" className="tooltip-label">
                  {/* New Wiring Point */}
                  {t("electrician.form.labels.new_wiring_point") ||
                    "New Wiring Point"}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.new_wiring_point.title") ||
                      "New Wiring Point"
                    }
                    description={t("electrician.tooltips.new_wiring_point.description", {
                      price: unit("new_wiring_point"),
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="nwp"
                  value={newWiringPoint}
                  setValue={setNewWiringPoint}
                />
              </div>
              <div className="ElectricianService-optionGroup">
                {/* <label>{t("electrician.form.labels.exhaust_fan_setup")}</label> */}
                <label htmlFor="exhaustfansetup" className="tooltip-label">
                  {/* Main Circuit Board Setup */}
                  {t("electrician.form.labels.main_circuit_board_setup") ||
                    "Main Circuit Board Setup"}
                  <ServiceTooltip
                    title={
                      t(
                        "electrician.tooltips.main_circuit_board_setup.title"
                      ) || "Main Circuit Board Setup"
                    }
                    description={t("electrician.tooltips.main_circuit_board_setup.description", {
                      price: unit("main_circuit_board_setup"),
                    })}

                  />
                </label>
                <PlusMinusInput
                  id="mcbs"
                  value={mainCircuitBoardSetup}
                  setValue={setMainCircuitBoardSetup}
                />
              </div>

              <div className="ElectricianService-optionGroup">
                <label htmlFor="needsCheckup" className="tooltip-label">
                  {t("electrician.form.labels.needs_checkup")}
                  <ServiceTooltip
                    title={
                      t("electrician.tooltips.needs_checkup.title") ||
                      "Electrical Checkup / Diagnosis"
                    }
                    description={t("electrician.tooltips.needs_checkup.description", {
                      price: CHECKUP_FEE,
                    })}

                  />
                </label>
                <select
                  id="electricalCheckup"
                  value={electricalCheckup ? "yes" : "no"}
                  onChange={(e) =>
                    setElectricalCheckup(e.target.value === "yes")
                  }
                >
                  <option value="no">
                    {t("electrician.form.labels.needs_checkup_options.no")}
                  </option>
                  <option value="yes">
                    {t("electrician.form.labels.needs_checkup_options.yes")}
                  </option>
                </select>
              </div>

              {/* <div className="ElectricianService-optionGroup">
                
                <label htmlFor="exhaustfanrepair" className="tooltip-label">
    {t("electrician.form.labels.exhaust_fan_repair")}
    <ServiceTooltip
      title={t("electrician.tooltips.exhaust_fan_repair.title") || "Exhaust Fan Repair"}
      description={t("electrician.tooltips.exhaust_fan_repair.description") || "Fan blades stuck or motor humming loudly? Repair cleans, lubricates, and fixes wiring in exhaust fans to restore airflow, reducing humidity and mold risks in your space."}
    />
  </label>
                <PlusMinusInput
                  value={exhaustFanRepair}
                  setValue={setExhaustFanRepair}
                />
              </div>
              <div className="ElectricianService-optionGroup">

                <label htmlFor="drillwallholes" className="tooltip-label">
    {t("electrician.form.labels.drill_wall_holes")}
    <ServiceTooltip
      title={t("electrician.tooltips.drill_wall_holes.title") || "Drill Wall Holes"}
      description={t("electrician.tooltips.drill_wall_holes.description") || "Mounting shelves, TVs, or AC units requires clean wall holes? We drill precisely with dust control and safety checks to avoid pipes or wires, making your installations sturdy and neat."}
    />
  </label>
                <PlusMinusInput
                  value={drillWallHoles}
                  setValue={setDrillWallHoles}
                />
              </div> */}
            </div>

            {rebookState && prevServitorName && (
              <div className="rebook-same-servitor">
                <label>
                  <input
                    type="checkbox"
                    checked={useSameServitor}
                    onChange={() => setUseSameServitor(!useSameServitor)}
                  />
                  {/* {t('electrician.form.rebook_same_servitor')} */}
                  {/* {` Do you want to book ${prevServitorName} again?`} */}
                  <span className="rebook-text">
                    {t("electrician.form.rebook_same_servitor_prefix")}
                    <span className="strong-name">{prevServitorName}</span>
                    {t("electrician.form.rebook_same_servitor_suffix")}
                  </span>
                </label>
              </div>
            )}

            {/* ---------- Price Breakdown Card (like AC) ---------- */}
            {breakdownRows.length > 0 && (
              <div
                className="ElectricianService-breakdownCard"
                aria-live="polite"
              >
                <div className="ElectricianService-breakdownHeader">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
                  </svg>
                  <span>
                    {t("electrician.breakdown.title", "Price Breakdown")}
                  </span>
                </div>
                <ul className="ElectricianService-breakdownList">
                  {breakdownRows.map((row, idx) => (
                    <li key={idx} className="ElectricianService-breakdownRow">
                      <span className="ElectricianService-breakdownLabel">
                        {row.label}
                      </span>
                      <span className="ElectricianService-breakdownRight">
                        {row.calc && (
                          <span className="ElectricianService-breakdownCalc">
                            {row.calc}
                          </span>
                        )}
                        <span className="ElectricianService-breakdownTotal">
                          {row.total}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Price Display */}
            <div className="ElectricianService-priceDisplay">
              {/* <span>Estimated Price: {calculatePrice()} tk</span> */}
              <span>
                {t("electrician.form.price_display", {
                  price: calculatePrice(),
                })}
              </span>
              {/* <small>(Final price may vary based on complexity)</small> */}
            </div>

            {/* Pricing note banner */}
            <div
              className="ElectricianService-priceNote"
              role="note"
              aria-live="polite"
            >
              <div
                className="ElectricianService-priceNote-icon"
                aria-hidden="true"
              >
                {/* small star icon (inline SVG so no extra imports) */}
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="currentColor"
                >
                  <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <div className="ElectricianService-priceNote-content">
                <div className="ElectricianService-priceNote-title">
                  {t("electrician.price_note.title")}
                </div>
                <p className="ElectricianService-priceNote-text">
                  <strong>
                    {t("electrician.price_note.service_charges_only_label")}
                  </strong>{" "}
                  {t("electrician.price_note.body")}
                </p>
              </div>
            </div>

            {/* Booking Details */}
            <div className="ElectricianService-bookingDetails">
              <div className="ElectricianService-optionGroup">
                <label htmlFor="date">
                  {/* Preferred Date */}
                  {t("electrician.form.labels.date")}
                </label>
                {/* <input type="date" id="date" name="date" min={todayDate} onChange={(e) => setSelectedDate(e.target.value)} required /> */}
                <div className="ElectricianService-dateInputWrapper">
                  {/* DatePicker Input */}
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MMM-yyyy"
                    minDate={new Date()} // blocks past dates
                    // placeholderText="Select a date"
                    placeholderText={t("electrician.form.labels.date")}
                    className="ElectricianService-dateInput"
                  />
                  {/* Calendar Icon */}
                  <FaCalendarAlt
                    className="ElectricianService-dateIcon"
                    onClick={() =>
                      document
                        .querySelector(
                          ".react-datepicker__input-container input"
                        )
                        .click()
                    }
                  />
                </div>
              </div>
              <div className="ElectricianService-optionGroup">
                <label htmlFor="time">
                  {/* Preferred Time */}
                  {t("electrician.form.labels.time")}
                </label>
                <select id="time" name="time" required>
                  {generateTimeSlots(selectedDate).map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* <h3 className="ElectricianService-sectionTitle">
            <i className="fas fa-comment-alt"></i>
            {t("electrician.form.remarks_title")}{" "}
          </h3> */}
            <div className="ElectricianService-serviceOptions">
              <div className="ElectricianService-optionGroup ElectricianService-fullWidth">
                <label htmlFor="remarks">
                  <i className="fas fa-comment-alt"></i>
                  {t("electrician.form.labels.remarks")}
                </label>
                <textarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder={t("electrician.form.placeholders.remarks")}
                  className="ElectricianService-textarea"
                  rows="2"
                />
              </div>
            </div>

            <button type="submit"
              className="ElectricianService-actionBtn"
              disabled={!hasAnySelection}
              aria-disabled={!hasAnySelection}

            >
              {/* Book Service Now */}
              {/* {rebookState ? "Confirm Rebooking" : "Book Service Now"} */}
              {rebookState
                ? t("electrician.form.rebook_button")
                : t("electrician.form.book_button")}
            </button>
          </form>

          <div className="ElectricianService-infoBox">
            <h4>{t("electrician.info_box.title")}</h4>{" "}
            {/* CHANGED: Added translation */}
            <p>{t("electrician.info_box.description")}</p>{" "}
            {/* CHANGED: Added translation */}
          </div>

          <div className="ElectricianService-additionalInfo">
            <div className="ElectricianService-sectionCard">
              <h2 className="ElectricianService-sectionTitle">
                {t("electrician.additional_info.how_to_place_order.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <ol className="ElectricianService-stepList">
                {t("electrician.additional_info.how_to_place_order.steps", {
                  returnObjects: true,
                }).map(
                  (step, idx /* CHANGED: Added translation for array */) => (
                    <li key={idx}>{step}</li>
                  )
                )}
              </ol>
            </div>

            <div className="ElectricianService-row2col">
              <div className="ElectricianService-sectionCard ElectricianService-gradientBg2">
                <h2 className="ElectricianService-sectionTitle">
                  {t("electrician.additional_info.why_choose_HelpNao.title")}{" "}
                  {/* CHANGED: Added translation */}
                </h2>
                <p className="ElectricianService-sectionText">
                  {t(
                    "electrician.additional_info.why_choose_HelpNao.description"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                </p>
                <div className="ElectricianService-featureGrid">
                  {t("electrician.additional_info.why_choose_HelpNao.features", {
                    returnObjects: true,
                  }).map(
                    (
                      feature,
                      idx /* CHANGED: Added translation for array */
                    ) => (
                      <div key={idx} className="ElectricianService-featureItem">
                        <i
                          className={`fas fa-${idx === 0
                              ? "balance-scale"
                              : idx === 1
                                ? "user-shield"
                                : idx === 2
                                  ? "mobile-alt"
                                  : "headset"
                            } ElectricianService-featureIcon`}
                          aria-hidden="true"
                        ></i>
                        <p>{feature}</p>
                      </div>
                    )
                  )}
                </div>
              </div>

              <div className="ElectricianService-sectionCard ElectricianService-gradientBg">
                <h2 className="ElectricianService-sectionTitle">
                  {t("electrician.additional_info.key_features.title")}{" "}
                  {/* CHANGED: Added translation */}
                </h2>
                <div className="ElectricianService-featureGrid">
                  {t("electrician.additional_info.key_features.features", {
                    returnObjects: true,
                  }).map(
                    (
                      feature,
                      idx /* CHANGED: Added translation for array */
                    ) => (
                      <div key={idx} className="ElectricianService-featureItem">
                        <i
                          className={`fas fa-${idx === 0
                              ? "clock"
                              : idx === 1
                                ? "shield-alt"
                                : idx === 2
                                  ? "check-circle"
                                  : idx === 3
                                    ? "credit-card"
                                    : "credit-card"
                            } ElectricianService-featureIcon`}
                          aria-hidden="true"
                        ></i>
                        <p>{feature}</p>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            {/* <div className="ElectricianService-sectionCard">
              <h2 className="ElectricianService-sectionTitle">
                {t("electrician.additional_info.mdb_mcb_service.title")}{" "}
              </h2>
              <div className="ElectricianService-mdbmcbGrid">
                <div className="ElectricianService-mdbmcbItem">
                  <i
                    className="fas fa-bolt ElectricianService-mdbmcbIcon"
                    aria-hidden="true"
                  ></i>
                  <div>
                    <h3>
                      {t(
                        "electrician.additional_info.mdb_mcb_service.mdb.title"
                      )}
                    </h3>{" "}
                    <p>
                      {t(
                        "electrician.additional_info.mdb_mcb_service.mdb.description"
                      )}
                    </p>{" "}
                  </div>
                </div>
                <div className="ElectricianService-mdbmcbItem">
                  <i
                    className="fas fa-bolt ElectricianService-mdbmcbIcon"
                    aria-hidden="true"
                  ></i>
                  <div>
                    <h3>
                      {t(
                        "electrician.additional_info.mdb_mcb_service.mcb.title"
                      )}
                    </h3>{" "}
                    <p>
                      {t(
                        "electrician.additional_info.mdb_mcb_service.mcb.description"
                      )}
                    </p>{" "}
                  </div>
                </div>
              </div>
            </div> */}

            <div className="ElectricianService-sectionCard ElectricianService-gradientBg3">
              <h2 className="ElectricianService-sectionTitle">
                {t("electrician.additional_info.order_tracking.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <div className="ElectricianService-orderTrackIcon">
                <i className="fas fa-file-alt" aria-hidden="true"></i>
              </div>
              <p className="ElectricianService-sectionText ElectricianService-centerText">
                {t("electrician.additional_info.order_tracking.description")}{" "}
                {/* CHANGED: Added translation */}
              </p>
            </div>
          </div>
        </div>

        {/* Order Form Modal */}
        {showOrderForm && (
          <ElectricianOrderForm
            onClose={() => setShowOrderForm(false)}
            onSubmit={handleOrderSubmit}
            formData={formData}
            user={user}
            previousServitorName={prevServitorName}
          />
        )}

        {/* Prompt Login Modal */}
        {showLoginPrompt && (
          <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
        )}
      </div>

      {/* Add Feedback Section */}
      <div className="electrician-feedback-section">
        <FeedbackPage serviceType="Electrician" />
      </div>

      <Footer />
    </>
  );
};

export default Electrician;
